var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

(function () {
  function r(e, n, t) {
    function o(i, f) {
      if (!n[i]) {
        if (!e[i]) {
          var c = "function" == typeof require && require;if (!f && c) return c(i, !0);if (u) return u(i, !0);var a = new Error("Cannot find module '" + i + "'");throw a.code = "MODULE_NOT_FOUND", a;
        }var p = n[i] = { exports: {} };e[i][0].call(p.exports, function (r) {
          var n = e[i][1][r];return o(n || r);
        }, p, p.exports, r, e, n, t);
      }return n[i].exports;
    }for (var u = "function" == typeof require && require, i = 0; i < t.length; i++) {
      o(t[i]);
    }return o;
  }return r;
})()({ 1: [function (require, module, exports) {
    (function (global, setImmediate) {
      (function (global) {

        //
        // Check for native Promise and it has correct interface
        //

        var NativePromise = global['Promise'];
        var nativePromiseSupported = NativePromise &&
        // Some of these methods are missing from
        // Firefox/Chrome experimental implementations
        'resolve' in NativePromise && 'reject' in NativePromise && 'all' in NativePromise && 'race' in NativePromise &&
        // Older version of the spec had a resolver object
        // as the arg rather than a function
        function () {
          var resolve;
          new NativePromise(function (r) {
            resolve = r;
          });
          return typeof resolve === 'function';
        }();

        //
        // export if necessary
        //

        if (typeof exports !== 'undefined' && exports) {
          // node.js
          exports.Promise = nativePromiseSupported ? NativePromise : Promise;
          exports.Polyfill = Promise;
        } else {
          // AMD
          if (typeof define == 'function' && define.amd) {
            define(function () {
              return nativePromiseSupported ? NativePromise : Promise;
            });
          } else {
            // in browser add to global
            if (!nativePromiseSupported) global['Promise'] = Promise;
          }
        }

        //
        // Polyfill
        //

        var PENDING = 'pending';
        var SEALED = 'sealed';
        var FULFILLED = 'fulfilled';
        var REJECTED = 'rejected';
        var NOOP = function NOOP() {};

        function isArray(value) {
          return Object.prototype.toString.call(value) === '[object Array]';
        }

        // async calls
        var asyncSetTimer = typeof setImmediate !== 'undefined' ? setImmediate : setTimeout;
        var asyncQueue = [];
        var asyncTimer;

        function asyncFlush() {
          // run promise callbacks
          for (var i = 0; i < asyncQueue.length; i++) {
            asyncQueue[i][0](asyncQueue[i][1]);
          } // reset async asyncQueue
          asyncQueue = [];
          asyncTimer = false;
        }

        function asyncCall(callback, arg) {
          asyncQueue.push([callback, arg]);

          if (!asyncTimer) {
            asyncTimer = true;
            asyncSetTimer(asyncFlush, 0);
          }
        }

        function invokeResolver(resolver, promise) {
          function resolvePromise(value) {
            resolve(promise, value);
          }

          function rejectPromise(reason) {
            reject(promise, reason);
          }

          try {
            resolver(resolvePromise, rejectPromise);
          } catch (e) {
            rejectPromise(e);
          }
        }

        function invokeCallback(subscriber) {
          var owner = subscriber.owner;
          var settled = owner.state_;
          var value = owner.data_;
          var callback = subscriber[settled];
          var promise = subscriber.then;

          if (typeof callback === 'function') {
            settled = FULFILLED;
            try {
              value = callback(value);
            } catch (e) {
              reject(promise, e);
            }
          }

          if (!handleThenable(promise, value)) {
            if (settled === FULFILLED) resolve(promise, value);

            if (settled === REJECTED) reject(promise, value);
          }
        }

        function handleThenable(promise, value) {
          var resolved;

          try {
            if (promise === value) throw new TypeError('A promises callback cannot return that same promise.');

            if (value && (typeof value === 'function' || (typeof value === "undefined" ? "undefined" : _typeof2(value)) === 'object')) {
              var then = value.then; // then should be retrived only once

              if (typeof then === 'function') {
                then.call(value, function (val) {
                  if (!resolved) {
                    resolved = true;

                    if (value !== val) resolve(promise, val);else fulfill(promise, val);
                  }
                }, function (reason) {
                  if (!resolved) {
                    resolved = true;

                    reject(promise, reason);
                  }
                });

                return true;
              }
            }
          } catch (e) {
            if (!resolved) reject(promise, e);

            return true;
          }

          return false;
        }

        function resolve(promise, value) {
          if (promise === value || !handleThenable(promise, value)) fulfill(promise, value);
        }

        function fulfill(promise, value) {
          if (promise.state_ === PENDING) {
            promise.state_ = SEALED;
            promise.data_ = value;

            asyncCall(publishFulfillment, promise);
          }
        }

        function reject(promise, reason) {
          if (promise.state_ === PENDING) {
            promise.state_ = SEALED;
            promise.data_ = reason;

            asyncCall(publishRejection, promise);
          }
        }

        function publish(promise) {
          var callbacks = promise.then_;
          promise.then_ = undefined;

          for (var i = 0; i < callbacks.length; i++) {
            invokeCallback(callbacks[i]);
          }
        }

        function publishFulfillment(promise) {
          promise.state_ = FULFILLED;
          publish(promise);
        }

        function publishRejection(promise) {
          promise.state_ = REJECTED;
          publish(promise);
        }

        /**
        * @class
        */
        function Promise(resolver) {
          if (typeof resolver !== 'function') throw new TypeError('Promise constructor takes a function argument');

          if (this instanceof Promise === false) throw new TypeError('Failed to construct \'Promise\': Please use the \'new\' operator, this object constructor cannot be called as a function.');

          this.then_ = [];

          invokeResolver(resolver, this);
        }

        Promise.prototype = {
          constructor: Promise,

          state_: PENDING,
          then_: null,
          data_: undefined,

          then: function then(onFulfillment, onRejection) {
            var subscriber = {
              owner: this,
              then: new this.constructor(NOOP),
              fulfilled: onFulfillment,
              rejected: onRejection
            };

            if (this.state_ === FULFILLED || this.state_ === REJECTED) {
              // already resolved, call callback async
              asyncCall(invokeCallback, subscriber);
            } else {
              // subscribe
              this.then_.push(subscriber);
            }

            return subscriber.then;
          },

          'catch': function _catch(onRejection) {
            return this.then(null, onRejection);
          }
        };

        Promise.all = function (promises) {
          var Class = this;

          if (!isArray(promises)) throw new TypeError('You must pass an array to Promise.all().');

          return new Class(function (resolve, reject) {
            var results = [];
            var remaining = 0;

            function resolver(index) {
              remaining++;
              return function (value) {
                results[index] = value;
                if (! --remaining) resolve(results);
              };
            }

            for (var i = 0, promise; i < promises.length; i++) {
              promise = promises[i];

              if (promise && typeof promise.then === 'function') promise.then(resolver(i), reject);else results[i] = promise;
            }

            if (!remaining) resolve(results);
          });
        };

        Promise.race = function (promises) {
          var Class = this;

          if (!isArray(promises)) throw new TypeError('You must pass an array to Promise.race().');

          return new Class(function (resolve, reject) {
            for (var i = 0, promise; i < promises.length; i++) {
              promise = promises[i];

              if (promise && typeof promise.then === 'function') promise.then(resolve, reject);else resolve(promise);
            }
          });
        };

        Promise.resolve = function (value) {
          var Class = this;

          if (value && (typeof value === "undefined" ? "undefined" : _typeof2(value)) === 'object' && value.constructor === Class) return value;

          return new Class(function (resolve) {
            resolve(value);
          });
        };

        Promise.reject = function (reason) {
          var Class = this;

          return new Class(function (resolve, reject) {
            reject(reason);
          });
        };
      })(typeof window != 'undefined' ? window : typeof global != 'undefined' ? global : typeof self != 'undefined' ? self : this);
    }).call(this, typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {}, require("timers").setImmediate);
  }, { "timers": 3 }], 2: [function (require, module, exports) {
    // shim for using process in browser
    var process = module.exports = {};

    // cached from whatever global is present so that test runners that stub it
    // don't break things.  But we need to wrap it in a try catch in case it is
    // wrapped in strict mode code which doesn't define any globals.  It's inside a
    // function because try/catches deoptimize in certain engines.

    var cachedSetTimeout;
    var cachedClearTimeout;

    function defaultSetTimout() {
      throw new Error('setTimeout has not been defined');
    }
    function defaultClearTimeout() {
      throw new Error('clearTimeout has not been defined');
    }
    (function () {
      try {
        if (typeof setTimeout === 'function') {
          cachedSetTimeout = setTimeout;
        } else {
          cachedSetTimeout = defaultSetTimout;
        }
      } catch (e) {
        cachedSetTimeout = defaultSetTimout;
      }
      try {
        if (typeof clearTimeout === 'function') {
          cachedClearTimeout = clearTimeout;
        } else {
          cachedClearTimeout = defaultClearTimeout;
        }
      } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
      }
    })();
    function runTimeout(fun) {
      if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
      }
      // if setTimeout wasn't available but was latter defined
      if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
      }
      try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
      } catch (e) {
        try {
          // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
          return cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
          // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
          return cachedSetTimeout.call(this, fun, 0);
        }
      }
    }
    function runClearTimeout(marker) {
      if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
      }
      // if clearTimeout wasn't available but was latter defined
      if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
      }
      try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
      } catch (e) {
        try {
          // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
          return cachedClearTimeout.call(null, marker);
        } catch (e) {
          // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
          // Some versions of I.E. have different rules for clearTimeout vs setTimeout
          return cachedClearTimeout.call(this, marker);
        }
      }
    }
    var queue = [];
    var draining = false;
    var currentQueue;
    var queueIndex = -1;

    function cleanUpNextTick() {
      if (!draining || !currentQueue) {
        return;
      }
      draining = false;
      if (currentQueue.length) {
        queue = currentQueue.concat(queue);
      } else {
        queueIndex = -1;
      }
      if (queue.length) {
        drainQueue();
      }
    }

    function drainQueue() {
      if (draining) {
        return;
      }
      var timeout = runTimeout(cleanUpNextTick);
      draining = true;

      var len = queue.length;
      while (len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
          if (currentQueue) {
            currentQueue[queueIndex].run();
          }
        }
        queueIndex = -1;
        len = queue.length;
      }
      currentQueue = null;
      draining = false;
      runClearTimeout(timeout);
    }

    process.nextTick = function (fun) {
      var args = new Array(arguments.length - 1);
      if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
          args[i - 1] = arguments[i];
        }
      }
      queue.push(new Item(fun, args));
      if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
      }
    };

    // v8 likes predictible objects
    function Item(fun, array) {
      this.fun = fun;
      this.array = array;
    }
    Item.prototype.run = function () {
      this.fun.apply(null, this.array);
    };
    process.title = 'browser';
    process.browser = true;
    process.env = {};
    process.argv = [];
    process.version = ''; // empty string to avoid regexp issues
    process.versions = {};

    function noop() {}

    process.on = noop;
    process.addListener = noop;
    process.once = noop;
    process.off = noop;
    process.removeListener = noop;
    process.removeAllListeners = noop;
    process.emit = noop;
    process.prependListener = noop;
    process.prependOnceListener = noop;

    process.listeners = function (name) {
      return [];
    };

    process.binding = function (name) {
      throw new Error('process.binding is not supported');
    };

    process.cwd = function () {
      return '/';
    };
    process.chdir = function (dir) {
      throw new Error('process.chdir is not supported');
    };
    process.umask = function () {
      return 0;
    };
  }, {}], 3: [function (require, module, exports) {
    (function (setImmediate, clearImmediate) {
      var nextTick = require('process/browser.js').nextTick;
      var apply = Function.prototype.apply;
      var slice = Array.prototype.slice;
      var immediateIds = {};
      var nextImmediateId = 0;

      // DOM APIs, for completeness

      exports.setTimeout = function () {
        return new Timeout(apply.call(setTimeout, window, arguments), clearTimeout);
      };
      exports.setInterval = function () {
        return new Timeout(apply.call(setInterval, window, arguments), clearInterval);
      };
      exports.clearTimeout = exports.clearInterval = function (timeout) {
        timeout.close();
      };

      function Timeout(id, clearFn) {
        this._id = id;
        this._clearFn = clearFn;
      }
      Timeout.prototype.unref = Timeout.prototype.ref = function () {};
      Timeout.prototype.close = function () {
        this._clearFn.call(window, this._id);
      };

      // Does not start the time, just sets up the members needed.
      exports.enroll = function (item, msecs) {
        clearTimeout(item._idleTimeoutId);
        item._idleTimeout = msecs;
      };

      exports.unenroll = function (item) {
        clearTimeout(item._idleTimeoutId);
        item._idleTimeout = -1;
      };

      exports._unrefActive = exports.active = function (item) {
        clearTimeout(item._idleTimeoutId);

        var msecs = item._idleTimeout;
        if (msecs >= 0) {
          item._idleTimeoutId = setTimeout(function onTimeout() {
            if (item._onTimeout) item._onTimeout();
          }, msecs);
        }
      };

      // That's not how node.js implements it but the exposed api is the same.
      exports.setImmediate = typeof setImmediate === "function" ? setImmediate : function (fn) {
        var id = nextImmediateId++;
        var args = arguments.length < 2 ? false : slice.call(arguments, 1);

        immediateIds[id] = true;

        nextTick(function onNextTick() {
          if (immediateIds[id]) {
            // fn.call() is faster so we optimize for the common use-case
            // @see http://jsperf.com/call-apply-segu
            if (args) {
              fn.apply(null, args);
            } else {
              fn.call(null);
            }
            // Prevent ids from leaking
            exports.clearImmediate(id);
          }
        });

        return id;
      };

      exports.clearImmediate = typeof clearImmediate === "function" ? clearImmediate : function (id) {
        delete immediateIds[id];
      };
    }).call(this, require("timers").setImmediate, require("timers").clearImmediate);
  }, { "process/browser.js": 2, "timers": 3 }], 4: [function (require, module, exports) {
    /**
     * 引用zepto版本发生变化，解决xhrFields跨域的兼容性问题
     * 相关文章：http://www.tuicool.com/articles/qMFzy2
     * 2017-08-22 11:44:40
     * 修改为兑吧活动工具专用base.js, 引入兑吧public
     */

    require('../../../../unit/lib/lib-zepto/1.2.0/zepto.min'); //zepto
    require('../../../../unit/common/js/checkoutWebp'); // webp判断
    require('../../../../unit/lib/lib-cookie/1.0.0/cookie'); // cookie
    require('../../../../unit/lib/lib-loader');
    window.Promise = require('es6-promise-polyfill').Promise;
    // require('./hook');
    require('../public/3.0.1/public');
    // click 300ms延迟 调用 FastClick(document.body);
    window.FastClick = require('../../../../unit/lib/lib-fastclick/1.0.0/fastclick');
    window._cdnFallback = function (node) {
      throw new Error('files not exits: ' + node.outerHTML);
    };
  }, { "../../../../unit/common/js/checkoutWebp": 10, "../../../../unit/lib/lib-cookie/1.0.0/cookie": 11, "../../../../unit/lib/lib-fastclick/1.0.0/fastclick": 12, "../../../../unit/lib/lib-loader": 13, "../../../../unit/lib/lib-zepto/1.2.0/zepto.min": 14, "../public/3.0.1/public": 7, "es6-promise-polyfill": 1 }], 5: [function (require, module, exports) {
    /**
     * @note    活动已结束推荐位弹窗
     * @author  zcc <zcc@duiba.com.cn>
     * @create  2017-09-06 11:07:16
     * @modify  
     * @des     
     *          
     */
    ;
    (function ($) {
      $(function () {

        var GameOverModal = {
          show: function show(options) {
            var _this = this;

            // 调用客户端获取推荐位活动统一接口
            window.recommendModal.loadData(function () {
              var $html = _this.render();
              $('body').append($html);
              setTimeout(function () {
                $('.gameover-wrapper').addClass('show');
              }, 100);

              setTimeout(function () {
                window.DB && window.DB.exposure && window.DB.exposure.initLog();
              }, 500);

              $('.gameover-modal').on('click', '.gameover-close', function () {
                $('.gameover-wrapper').removeClass('show');
                setTimeout(function () {
                  // 收起动画完成再remove掉
                  $('.gameover-modal').remove();
                  options.onClose && options.onClose();
                }, 200);
              });
            });
          },
          render: function render() {
            var data = window.recData;
            if (!CFG.isOpenRecommend) {
              data = [];
            }
            data.forEach(function (item) {
              // item.logo = item.bannerNewImage ? item.bannerNewImage : item.bannerImage;
              // item.imgCls = item.bannerNewImage ? 'img-new' : 'img-old';
              // 2017-09-21 10:16:39
              // 750尺寸图片可能存在，但可能是默认图，所以暂时去掉750的图片
              item.logo = item.bannerImage;
              item.imgCls = 'img-old';
              if (typeof ''.ossimg === 'function') {
                item.logo = item.logo.ossimg();
              }
            });
            var _html = '<div class="gameover-modal">\n          <div class="gameover-wrapper" data-length="' + data.length + "\">\n            <div class=\"gameover-tip\">\n              <img src=\"//yun.duiba.com.cn/activity/images/over.png\" alt=\"\" />\n              <p class=\"tip-title\">\u6765\u665A\u4E86\uFF0C\u6D3B\u52A8\u7ED3\u675F\u5566\uFF01</p>\n            </div>\n            <div class=\"gameover-rec-list\">\n              <p>\u770B\u770B\u5176\u4ED6\u6D3B\u52A8\u5427</p>\n              " + data.map(function (item) {
              return '\n                <a href="' + item.url + '">\n                  <div class="img-wrapper ' + item.imgCls + '">\n                    <img src="' + item.logo + '" alt="" db-exposure=' + item.emdDpmJson + " />\n                  </div>\n                  <span class=\"rec-btn\">\u9A6C\u4E0A\u53C2\u52A0</span>\n                </a>\n              ";
            }).join('') + '\n            </div>\n            <span class="gameover-close"></span>\n          </div>\n        </div>';
            return _html;
          }
        };

        window.GameOverModal = GameOverModal;
      });
    })(Zepto);
  }, {}], 6: [function (require, module, exports) {
    /**
     * @note    新推荐位活动弹窗组件
     * @author  weikaide <weikaide@duiba.com.cn>
     * @create  2017.2.15
     * @modify  
     * @des     推荐位活动组件，样式请引入/unit/common/less/recommendModal/recommendModal.less
     *          window.recommendModal.show();
     */
    ;
    (function ($) {
      window.recData = [];
      // CFG.isOpenRecommend是否开启推荐位
      // 当值===false，客户端不调用推荐位数据接口
      var ready = !CFG.isOpenRecommend;
      var recommendModal = {
        ready: ready, // 状态，数据是否已加载完成
        /**
         * show modal
         * @return {[type]} [description]
         */
        show: function show() {
          var _this = this;

          var self = this;

          this.loadData(function () {
            _this.render();
            setTimeout(function () {
              window.DB && window.DB.exposure && window.DB.exposure.initLog();
            }, 500);
          });
        },
        /**
         * 加载数据
         * @return {[type]} [description]
         */
        loadData: function loadData(callback) {
          var self = this;
          if (self.ready) {
            callback && callback();
          } else {
            $.ajax({
              url: CFG.recommendQueue,
              type: 'get',
              dataType: 'json',
              data: {
                operatingActivityId: CFG.actId,
                requestType: "activity"
              },
              success: function success(result) {
                if (result.success && result.recommendQueueList) {
                  window.recData = result.recommendQueueList;
                  window.recData.forEach(function (item) {
                    item.ossImage = item.recommendImage;
                    if (typeof ''.ossimg === 'function') {
                      item.ossImage = item.ossImage.ossimg();
                    }
                  });
                }
                self.ready = true;
                callback && callback();
              },
              error: function error() {
                self.ready = true;
                console.log('get recommend queue error');
                callback && callback();
              }
            });
          }
        },
        /**
         * dom渲染
         * @return {[type]} [description]
         */
        render: function render() {
          var self = this;
          var empty = '';
          if (!CFG.isOpenRecommend || !window.recData.length) {
            empty = 'empty';
          }
          var _html = '<div id="recommend-modal" class="recommend-modal">\n        <div class="close"></div>\n        <div class="recommend-modal-dialog ' + empty + "\">\n          <div class=\"recommend-tip\"></div>\n          <div class=\"recommend\">\n            <header>\n              <i></i>\n              <span>\u66F4\u591A\u6D3B\u52A8</span>\n              <i></i>\n            </header>\n            <section>\n              " + window.recData.map(function (item) {
            return '\n                <a class="recommend-group" href="' + item.url + '" ><img src="' + item.ossImage + '" db-exposure=' + item.emdDpmJson + ' /></a>\n              ';
          }).join('') + '\n            </section>\n          </div>\n        </div>\n      </div>';
          if ($('#recommend-modal').length) {
            $('#recommend-modal').remove();
          }
          this.$modal = $(_html);
          $('body').append(this.$modal);

          this.$modal.show();
          this.$modal.on('click', '.close', function () {
            self.$modal.remove();
          });
        }
      };
      window.recommendModal = recommendModal;
    })(Zepto);
  }, {}], 7: [function (require, module, exports) {
    var _typeof = typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol" ? function (obj) {
      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
    } : function (obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
    };

    /**
     * 活动工具public.js
     * 提供公用接口
     * zcc@duiba.com.cn
     * 2017-08-02 17:45:29  改造，兼容自定义抽奖工具
     * @return {[type]} [description]
     */
    !function () {
      require('../../requireStyle/3.0.0/requireStyle');
      require('../../showModal/1.0/showModal');
      require('../../components/recommendModal/index');

      $(function () {
        FastClick(document.body);

        // 设置隐藏属性和改变可见属性的事件的名称
        var hidden, visibilityChange;
        if (typeof document.hidden !== 'undefined') {
          // Opera 12.10 and Firefox 18 and later support
          hidden = 'hidden';
          visibilityChange = 'visibilitychange';
        } else if (typeof document.msHidden !== 'undefined') {
          hidden = 'msHidden';
          visibilityChange = 'msvisibilitychange';
        } else if (typeof document.webkitHidden !== 'undefined') {
          hidden = 'webkitHidden';
          visibilityChange = 'webkitvisibilitychange';
        }

        function handleVisibilityChange(e) {
          var h = document[hidden];
          if (e && e.detail) {
            // 兼容飞猪，app注入e.detail
            h = e.detail.hidden;
            duibaPublic.feizhuFlag = true;
          }
          //置入app当前是否在后台运行的状态
          window.backgroundFlag = h;

          //判断活动动作是否执行完毕
          if (duibaPublic.activityFLag) {
            return;
          }

          if (h) {
            // 后台时
            if (duibaPublic.initFlag) {
              // 已完成初始化
              duibaPublic.backgroundStopAnimation();
            }
          } else {
            // 前台时
            if (duibaPublic.initFlag) {
              // 已完成初始化
              duibaPublic.backgroundStartAnimation();
            } else {
              // 还没有完成初始化，这个时候需要把没有完成的初始化继续完成
              duibaPublic.initFunction && duibaPublic.initFunction();
            }
          }
        }

        // 如果浏览器不支持addEventListener 或 Page Visibility API 给出警告
        if (typeof document.addEventListener === 'undefined' || typeof document[hidden] === 'undefined') {
          console.log('this requires a browser, such as Google Chrome or Firefox, that supports the Page Visibility API.');
        } else {
          // 处理页面可见属性的改变
          document.addEventListener(visibilityChange, handleVisibilityChange, false);
        }
      });

      var duibaPublic = {
        needCreditsWrapper: '#needCredits',
        myCreditsWrapper: '#myCredits',
        orderCount: 0, // 订单查询次数
        orderLoopCount: 20, // 查询订单接口轮询最大次数
        couponFiles: [], // 优惠券弹窗皮肤文件
        orderTimes: [500, 200, 200], // 查询订单接口的延时时间，第一次500ms，以此类推，没有则是1000ms
        _UA: navigator.userAgent.toLowerCase(),
        entranceDesc: CFG.entranceDesc ? CFG.entranceDesc : '也可到首页“兑换记录”领奖，24小时内有效',
        activityFLag: false, //活动当前状态标识：false：没有不能被打断的动作，true：正在执行不能被打断的动作
        backgroundFlag: false, //app当前后台状态标识：false：前台运行，true：后台运行
        animationElements: [], //DB-ANIMATION元素s
        feizhuFlag: false, //兼容飞猪，判断当前平台是否是飞猪
        initFlag: false,
        /**
         * 基本接口参数
         */
        AJAX_PARAMS: {
          hdType: CFG.hdType,
          hdToolId: CFG.hdToolId,
          preview: CFG.preview,
          actId: CFG.actId,
          adslotId: CFG.adslotId
        },
        /**
         * ajax
         */
        duibaAjax: function duibaAjax(options) {
          var _defaults = {
            url: '',
            type: 'post',
            dataType: 'json',
            data: {},
            cache: false,
            success: function success() {},
            error: function error() {}
          };
          options = $.extend(true, _defaults, options);
          return $.ajax(options);
        },
        /**
         * 新版埋点 唤起登录访问
         */
        loginExposure: function loginExposure() {
          if (!CFG.login) {
            return false;
          }
          var _defaults = {
            url: CFG.login
          };
          return this.duibaAjax(_defaults);
        },
        /**
         * 活动工具获取初始化数据接口，积分/样式配置, Promise
         * @param  {Function} callback [description]
         * @return {[type]}            [description]
         */
        getInitData: function getInitData(callback, styleConfig) {
          var self = this;
          var taskList = [self.ajaxElement()];
          // 如果不是自定义活动工具，且有styleConfig
          if (CFG.appName !== 'custom' && styleConfig) {
            taskList.push(self.ajaxStyle(styleConfig));
          }
          window.dbApiStart = +new Date();
          Promise.all(taskList).then(function (result) {
            window.dbApiEnd = +new Date();
            callback && callback(result);
            self.duibaPerformance();
          });
        },
        /**
         * 获取活动工具初始参数 新版 使用Promise
         * @return {[type]} [description]
         */
        ajaxElement: function ajaxElement() {
          var self = this;
          return new Promise(function (resolve, reject) {
            self.duibaAjax({
              url: CFG.getElement,
              data: self.AJAX_PARAMS,
              success: function success(result) {
                if (result.success) {
                  self.floatingId = result.floatingId;
                  self.couponFiles = [];
                  if (result.jsTest) {
                    self.couponFiles.push(result.jsTest);
                  }
                  if (result.cssTest) {
                    self.couponFiles.push(result.cssTest);
                  }
                  self.renderElement(result);
                  // 今日次数不足或永久次数不足，show出推荐位弹窗
                  if (result.element.status === 3 || result.element.status === 4) {
                    window.recommendModal && window.recommendModal.show();
                  }
                }
                resolve(result);
              },
              error: function error(_error) {
                self.showModal('networkError');
                reject(_error);
              }
            });
          });
        },
        /**
         * 获取活动工具样式配置 新版 使用Promise
         * @return {[type]} [description]
         */
        ajaxStyle: function ajaxStyle(styleConfig) {
          var self = this;
          return new Promise(function (resolve, reject) {
            requireStyle.init({
              url: CFG.styleConfig,
              data: {
                actId: CFG.actId,
                hdType: CFG.hdType,
                hdToolId: CFG.hdToolId
              },
              config: styleConfig,
              callback: {
                success: function success(result) {
                  window.dbStyleConfigEnd = +new Date();
                  resolve(result);
                },
                systemError: function systemError(error) {
                  self.showModal('systemError', {
                    message: error.message
                  });
                  reject(error);
                },
                networkError: function networkError(error) {
                  self.showModal('networkError');
                  reject(error);
                }
              }
            });
          });
        },
        /**
         * 获取活动工具初始参数
         * @param  {[type]} options [description]
         * @return {[type]}         [description]
         */
        getDuibaElement: function getDuibaElement(options) {
          var self = this;
          var defaults = {
            url: CFG.getElement,
            data: this.AJAX_PARAMS
          };
          options = $.extend(true, defaults, options);
          var succ = options.success;
          options.success = function (result) {
            if (result.success) {
              self.floatingId = result.floatingId;
              self.couponFiles = [];
              if (result.jsTest) {
                self.couponFiles.push(result.jsTest);
              }
              if (result.cssTest) {
                self.couponFiles.push(result.cssTest);
              }
              self.renderElement(result);
              // 今日次数不足或永久次数不足，show出推荐位弹窗
              if (result.element.status === 3 || result.element.status === 4) {
                window.recommendModal && window.recommendModal.show();
              }
            }
            succ && succ(result);
          };
          this.duibaAjax(options);
        },
        /**
         * 闯关游戏查询订单结果接口
         * @return {[type]} [description]
         */
        doThroughSubmit: function doThroughSubmit(options) {
          var _self = this;
          setTimeout(function () {
            var _defaults = {
              url: CFG.throughSubmit,
              data: {
                orderId: options.orderId
              }
            };
            options = $.extend(true, _defaults, options);
            window.xhr = _self.duibaAjax(options);
          }, 1000);
        },
        /**
         * 闯关游戏 获取关卡信息
         * @return {[type]} [description]
         */
        getThroughInfo: function getThroughInfo(options) {
          var _self = this,
              _defaults = {
            url: CFG.ajaxThroughInfo,
            data: {
              hdtoolId: CFG.hdToolId,
              throughId: 1
            }
          };
          options = $.extend(true, _defaults, options);
          this.duibaAjax(options);
        },
        /**
         * 下订单
         * @return {[type]} [description]
         */
        getOrderId: function getOrderId(callback) {
          var self = this;
          self.orderCount = 0;
          this.getDuibaOrderId({
            success: function success(result) {
              if (result.success) {
                againOrderId = null;
                self.getOrderStatus(result.orderId, callback);
              } else {
                self.showModal(self.getCustomErrorCode(result.status), result);
              }
            },
            tokenCallback: function tokenCallback(error) {
              self.showModal(error);
            }
          });
        },
        /**
         * 查询订单
         * @param  {[type]} orderId [description]
         * @return {[type]}         [description]
         */
        getOrderStatus: function getOrderStatus(orderId, callback) {
          var self = this;
          this.postDuibaOrder({
            orderId: orderId,
            timeout: 10000,
            success: function success(result) {
              if (result.success) {
                if (result.result === 0) {
                  if (self.orderCount < self.orderLoopCount) {
                    self.orderCount++;
                    self.getOrderStatus(orderId, callback);
                  } else {
                    self.showModal('systemError');
                  }
                } else {
                  if (result.againTag) {
                    againOrderId = result.againTag;
                  }
                  self.renderElement(result);
                  // 推荐位次数+1
                  window.LoadRecommendSkin && window.LoadRecommendSkin.addJoinNum();
                  callback && callback(result);
                }
              } else {
                self.showModal('systemError', result);
              }
            }
          });
        },
        /**
         * 活动工具生成订单
         * @param  {[type]} options [description]
         * @return {[type]}         [description]
         */
        getDuibaOrderId: function getDuibaOrderId(options) {
          var _self = this;
          getDuibaToken(function (data) {
            var _defaults = {
              url: CFG.doJoin,
              data: data
            };
            options = $.extend(true, _defaults, options);
            window.xhr = _self.duibaAjax(options);
          }, options.tokenCallback);
        },
        /**
         * 加载&渲染活动工具配置的样式
         * @param  {[type]} options [description]
         * @return {[type]}         [description]
         */
        requireStyle: function (_requireStyle) {
          function requireStyle(_x) {
            return _requireStyle.apply(this, arguments);
          }

          requireStyle.toString = function () {
            return _requireStyle.toString();
          };

          return requireStyle;
        }(function (options) {
          var config = {
            url: CFG.styleConfig,
            data: {
              actId: CFG.actId,
              hdType: CFG.hdType,
              hdToolId: CFG.hdToolId
            }
          };
          config = $.extend(true, config, options);
          requireStyle.init(config);
        }),
        /**
         * 活动工具抽奖
         * @param  {[type]} options [description]
         * @return {[type]}         [description]
         */
        postDuibaOrder: function postDuibaOrder(options) {
          var _self = this;
          var time = this.orderTimes[this.orderCount] || 1000;
          setTimeout(function () {
            var _defaults = {
              url: CFG.quireOrder,
              data: {
                orderId: options.orderId,
                adslotId: CFG.adslotId,
                floatingId: _self.floatingId
              }
            };
            options = $.extend(true, _defaults, options);
            window.xhr = _self.duibaAjax(options);
          }, time);
        },
        /**
         * 答题获取答对题目数  后期可废弃，使用postQuestionOrder封装接口
         * @param  {[type]} element [description]
         * @return {[type]}         [description]
         */
        getQuestionResult: function getQuestionResult(options) {
          var _self = this;
          setTimeout(function () {
            var _defaults = {
              url: CFG.doSubmit,
              data: {
                orderId: options.orderId,
                adslotId: CFG.adslotId,
                floatingId: _self.floatingId
              }
            };
            options = $.extend(true, _defaults, options);
            window.xhr = _self.duibaAjax(options);
          }, 1000);
        },
        /**
         * 答题获取答对题目数 new
         * @param  {[type]} element [description]
         * @return {[type]}         [description]
         */
        doQuestionSubmit: function doQuestionSubmit(options) {
          var _self = this;
          getDuibaToken(function (data) {
            var _defaults = {
              url: CFG.doSubmit,
              data: {
                adslotId: CFG.adslotId,
                floatingId: _self.floatingId,
                token: data.token
              }
            };
            options = $.extend(true, _defaults, options);
            window.xhr = _self.duibaAjax(options);
          }, function () {});
        },
        /**
         * 获取答题抽奖结果的封装函数，内部调用submit和getOrderStatus两个接口
         * @param  {[type]}   options  [description]
         * @param  {Function} callback [description]
         * @return {[type]}            [description]
         */
        postQuestionOrder: function postQuestionOrder(options, callback) {
          var self = this;
          this.doQuestionSubmit({
            data: options,
            success: function success(result) {
              if (result.success) {
                self.rightCount = result.rightCount;
                self.postDuibaOrder({
                  orderId: result.orderId,
                  timeout: 10000,
                  success: function success(res) {
                    callback && callback(res);
                  },
                  error: function error() {
                    self.showModal('networkError');
                  }
                });
              } else {
                self.showModal('systemError', result);
              }
            },
            error: function error() {
              self.showModal('networkError');
            }
          });
        },
        /**
         * 获取服务器时间
         * @return {[type]} [description]
         */
        getServiceTime: function getServiceTime() {
          return new Promise(function (resolve, reject) {
            $.ajax({
              url: '/serverTime/now',
              type: 'get',
              dataType: 'text',
              success: function success(res) {
                res = JSON.parse(res);
                if ((typeof res === 'undefined' ? 'undefined' : _typeof(res)) === 'object') {
                  res = +res.dateTime;
                } else {
                  res = +res;
                }
                resolve(res);
              },
              error: function error(e) {
                reject(e);
              }
            });
          });
        },
        /**
         * tiny-loader异步加载js、css，适用于对加载顺序没有要求的场景
         * @param  {Function} callback [description]
         * @return {[type]}            [description]
         */
        asyncLoder: function asyncLoder(callback, files) {
          // 如果使用配置的优惠券弹窗，则采用异步加载
          // 否则采用同步加载，防止优惠券组件js在common.js之前执行
          if (CFG.needCouponModal) {
            this.loaderFiles('async', callback, files);
          } else {
            this.loaderFiles('sync', callback, files);
          }
        },
        /**
         * tiny-loader按顺序加载js，适用于对加载顺序有要求的场景
         * @param  {Function} callback [description]
         * @return {[type]}            [description]
         */
        syncLoader: function syncLoader(callback, files) {
          this.loaderFiles('sync', callback, files);
        },
        /**
         * 加载非首屏的次要资源
         * @param  {[type]}   type     [description]
         * @param  {Function} callback [description]
         * @param  {[type]}   files    [description]
         * @return {[type]}            [description]
         */
        loaderFiles: function loaderFiles(type, callback, files) {
          if (!type) return false;
          var self = this;
          var _files = files || (CFG ? CFG.asyncFiles : null);
          if (!_files || !window.Loader) return;

          // 把common.js push到加载队列第一位
          if (window.commonUrl) {
            if (_files.indexOf(window.commonUrl) < 0) {
              _files.unshift(window.commonUrl);
            }
          }

          // 加载common.css
          if (window.commonCss) {
            if (_files.indexOf(window.commonCss) < 0) {
              _files.push(window.commonCss);
            }
          }

          Loader[type](_files, function () {
            // 加载推荐位皮肤
            window.LoadRecommendSkin && window.LoadRecommendSkin.init();
            callback && callback();
            // 如果需要加载ajaxElement接口提供优惠券弹窗样式
            // 依赖common.js，第一次load完后再去加载弹窗js/css，保证在common.js之后加载
            if (CFG.needCouponModal && self.couponFiles.length) {
              Loader.async(self.couponFiles, function () {});
            }
          });
        },
        /**
         * 初始化奖品详情弹窗
         * @param  {[type]} cls [奖品 dom class]
         * @return {[type]}       [description]
         */
        initPrizeDetail: function initPrizeDetail(cls) {
          if (!cls) return false;
          $('body').on('click', cls, function () {
            var $item = $(this);
            if (CFG.isShowDetail && window.GetPrizeDetail) {
              new GetPrizeDetail({
                url: CFG.getPrizeDetail,
                prizeType: $item.data('type'),
                data: {
                  appItemId: $item.data('appitemid'),
                  itemId: $item.data('itemid'),
                  appId: CFG.appId
                }
              });
            }
          });
        },
        /**
         * 兑吧性能统计接口
         * @return {[type]} [description]
         */
        duibaPerformance: function duibaPerformance(t) {
          var _this = this;

          if (!window.performance) return;
          var pt = window.performance.timing;
          var time = t || 0;

          if (!pt.loadEventEnd) {
            if (time < 10) {
              setTimeout(function () {
                time++;
                _this.duibaPerformance(time);
              }, 1000);
            }
          } else {
            if (!window.dbApiStart || !window.dbApiEnd) {
              // 如果这几个不存在则不发送，排除获取数据ajax出错的情况
              return;
            }
            // dom解析时间
            var domComplete = pt.domComplete - pt.domInteractive;
            // domContentLoaded时间
            var domLoaded = pt.domContentLoadedEventEnd - pt.navigationStart;
            // onload时间
            var onload = pt.loadEventEnd - pt.navigationStart;
            // 白屏时间，初始化2个接口完成时间 - 准备加载新页面的起始时间
            var white = window.dbApiEnd - pt.navigationStart;
            // dbStyle 接口耗时
            var dbStyle = window.dbStyleConfigEnd - window.dbApiStart;

            var network = this.getNetwork();

            var url = '/statistics/activityPagePerf?hdType=' + CFG.appName + '&oaId=' + CFG.actId + '&hdToolId=' + CFG.hdToolId + '&skinName=' + CFG.skinName + '&domComplete=' + domComplete + '&domLoaded=' + domLoaded + '&onload=' + onload + '&white=' + white + '&dbStyle=' + dbStyle + '&network=' + network;
            this.duibaAjax({
              url: url
            });
          }
        },
        /**
         * 根据状态码生成"我的积分"文案
         * @param  {[type]} element [description]
         * @return {[type]}         [description]
         */
        getDuibaStatusText: function getDuibaStatusText(element) {
          var result = '';
          if (element) {
            switch (element.status) {
              case 3:
                result = '今日已抽完';
                break;
              case 4:
                result = '没有抽奖机会了！';
                break;
              case 5:
                result = "\u4ECA\u65E5\u514D\u8D39\uFF1A" + element.freeLimit + "\u6B21";
                break;
              case 6:
                result = '<span>' + element.needCredits + '</span>' + CFG.unitName + "/\u6BCF\u6B21";
                break;
              case 7:
                result = "\u514D\u8D39\u6B21\u6570\uFF1A" + element.freeLimit + "\u6B21";
                break;
              default:
                result = '没有抽奖机会了！';
            }
          }
          return result;
        },
        /**
         * 根据错误码生成错误消息对象
         * @param  {[type]} errorCode [description]
         * @return {[type]}           [description]
         */
        createErrorObject: function createErrorObject(errorCode, result) {
          var title = '',
              tip = '',
              btnText = '',
              link = '';
          result ? result : result = {};
          switch (errorCode) {
            case 'systemError':
              title = result.title ? result.title : '抽奖失败';
              tip = result.message;
              btnText = '再抽一次';
              break;
            case 'networkError':
              title = '噢哦，网络解析错误！';
              tip = '再试一遍吧~';
              btnText = '再试一遍';
              break;
            case 'noLogin':
              title = '未登录';
              tip = '你还没有登录哦~';
              btnText = '好的';
              break;
            case 'gameClose':
              title = '活动结束';
              tip = '该活动已经结束啦~';
              btnText = '知道了';
              break;
            case 'noCredits':
              title = "\u5662\u54E6\uFF0C" + CFG.btnUnitName + "\u4E0D\u8DB3\uFF01";
              tip = '多攒一些再来吧~';
              if (result.getCreditsLink) {
                link = result.getCreditsLink;
                btnText = '赚取更多' + CFG.btnUnitName;
              } else {
                btnText = '知道了';
              }
              break;
            case 'over':
              title = '抽奖次数已全部用完';
              tip = '已经没有次数啦~';
              btnText = '知道了';
              break;
            case 'todayOver':
              title = '今天抽奖次数已用完';
              tip = '明天再来哦~';
              btnText = '知道了';
              break;
            case 'noPrize':
              title = '哎呀，就差那么一点点~';
              tip = '别灰心，再来一次！';
              btnText = '再抽一次';
              break;
            case 'again':
              title = '恭喜您，中奖了';
              tip = '获得免费再抽一次';
              btnText = '再抽一次';
              break;
            case 'noQualification':
              title = '噢哦，您没有参与资格！';
              tip = '请刷新页面重试';
              btnText = '知道了';
            case 'tokenError':
              title = '网络开小差';
              tip = '请重试一下';
              btnText = '重试一下';
              break;
          }
          return {
            type: errorCode,
            title: title,
            tip: tip,
            btnText: btnText,
            link: link
          };
        },
        /**
         * 获得错误码
         * @return {[type]} [description]
         */
        getErrorCode: function getErrorCode(status) {
          var _code = '';
          switch (status) {
            case 1:
              // 未登录
              _code = 'noLogin';
              break;
            case 2:
              // 积分不足
              _code = 'noCredits';
              break;
            case 3:
              // 今日已抽完
              _code = 'todayOver';
              break;
            case 4:
              // 永久次数用完
              _code = 'over';
              break;
            case 5:
              // 活动已关闭
              _code = 'gameClose';
              break;
            default:
              // 系统错误
              _code = 'systemError';
          }
          return _code;
        },
        /**
         * 获得错误码, 自定义活动工具
         * @return {[type]} [description]
         */
        getCustomErrorCode: function getCustomErrorCode(status) {
          var _code = '';
          switch (status) {
            case 18:
              // 未登录
              _code = 'noLogin';
              break;
            case 1:
              // 积分不足
              _code = 'noCredits';
              break;
            case 3:
              // 今日已抽完
              _code = 'todayOver';
              break;
            case 4:
              // 永久次数用完
              _code = 'over';
              break;
            case 10:
              // 活动已结束
              _code = 'gameClose';
              break;
            case 20:
              // 无参与资格
              _code = 'noQualification';
              break;
            case 22:
              // 无参与资格
              _code = 'noQualification';
              break;
            case 24:
              // token校验失败
              _code = 'tokenError';
              break;
            default:
              // 系统错误
              _code = 'systemError';
          }
          return _code;
        },
        /**
         * iscroll组件click参数的值
         * @return {[type]} [description]
         */
        iScrollClick: function iScrollClick() {
          if (/iPhone|iPad|iPod|Macintosh/i.test(navigator.userAgent)) return false;
          if (/Chrome/i.test(navigator.userAgent)) return (/Android/i.test(navigator.userAgent)
          );
          if (/Silk/i.test(navigator.userAgent)) return false;
          if (/Android/i.test(navigator.userAgent)) {
            var s = navigator.userAgent.substr(navigator.userAgent.indexOf('Android') + 8, 3);
            return parseFloat(s[0] + s[3]) < 44 ? false : true;
          }
        },
        /**
         * 获取url中的参数
         * @param  {[type]} name [description]
         * @return {[type]}      [description]
         */
        getQueryString: function getQueryString(name) {
          var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)');
          var r = window.location.search.substr(1).match(reg);
          if (r != null) return unescape(r[2]);
          return null;
        },
        /**
         * 错误消息报告接口
         * @param  {[type]} data [description]
         * @return {[type]}      [description]
         */
        errorReport: function errorReport(data) {
          if (!data) {
            return false;
          }
          $.ajax({
            url: '/log/report',
            data: data,
            dataType: 'json',
            type: 'get',
            success: function success(res) {},
            error: function error(res) {}
          });
        },
        /**
         * 错误消息弹窗
         * @param  {[type]} type   [description]
         * @param  {[type]} result [description]
         * @return {[type]}        [description]
         */
        showModal: function showModal(type, result) {
          var _this2 = this;

          var _result = this.createErrorObject(type, result);
          window.errorMsgModal.show(_result);
          setTimeout(function () {
            _this2.gameReset && _this2.gameReset();
          }, 200);
        },
        /**
         * 展示奖品弹窗
         * @param  {[type]}   result   [description]
         * @param  {Function} callback [description]
         * @return {[type]}            [description]
         */
        showPrizeModal: function showPrizeModal(result, callback) {
          var self = this;
          var lottery = result.lottery;

          if (lottery.type == 'coupon' || lottery.type == 'lucky') {
            // 优惠券\福袋
            window.showCouponPrize && window.showCouponPrize({
              result: result,
              callback: {
                close: function close() {
                  // 触发推荐位皮肤
                  window.triggerRecommendSkin && window.triggerRecommendSkin();
                  callback && callback.close && callback.close();
                }
              }
            });
          } else {
            // 实物\直充\虚拟
            window.showObjectPrize && window.showObjectPrize({
              result: result,
              desc: self.entranceDesc,
              onclose: function onclose() {
                // 触发推荐位皮肤
                window.triggerRecommendSkin && window.triggerRecommendSkin();
                callback && callback.close && callback.close();
              }
            });
          }
        },
        /**
         * 页面元素渲染
         * @param  {[type]} result [description]
         * @return {[type]}        [description]
         */
        renderElement: function renderElement(result) {
          var element = result.element,
              _myCredits = '',
              _needCredits = '',
              _statusText = this.getDuibaStatusText(element);

          if (element.isCreditsTypeOpen) {
            // 免费抽奖
            _needCredits = '免费抽奖';
            _myCredits = _statusText;
          } else {
            _needCredits = _statusText;
            _myCredits = '我的' + CFG.btnUnitName + '：<span>' + element.myCredits + '</span>';
          }

          $(this.needCreditsWrapper).html(_needCredits);
          $(this.myCreditsWrapper).html(_myCredits);
        },
        /**
         * 获取客户端网络情况
         * @return {[type]} [description]
         */
        getNetwork: function getNetwork() {
          var network_state = null;
          var ua = window.navigator.userAgent;
          var con = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
          // 如果是微信
          if (/MicroMessenger/.test(ua)) {
            // 如果是微信6.0以上版本，用UA来判断
            if (/NetType/.test(ua)) {
              var type = ua.match(/NetType\/(\S*)/);
              network_state = type[1];
              // 如果是微信6.0以下版本，调用微信私有接口WeixinJSBridge
            } else {
              document.addEventListener('WeixinJSBridgeReady', function onBridgeReady() {
                WeixinJSBridge.invoke('getNetworkType', {}, function (e) {
                  network_state = e.err_msg;
                });
              });
            }
            // 如果支持navigator.connection
          } else if (con) {
            var network = con.type;
            network_state = network;
          }

          var connectType = ['bluetooth', 'cellular', 'ethernet', 'mixed', 'none', 'other', 'unknown', 'wifi', 'wimax'];
          if (!isNaN(network_state)) {
            network_state = connectType[parseInt(network_state)];
          }
          return network_state;
        },
        /**
         * 判断当前活动与后台运行状态，控制是否停止动画
         */
        backgroundPending: function backgroundPending() {
          if (window.backgroundFlag && !this.activityFLag) {
            this.backgroundStopAnimation();
          }
        },
        backgroundStopAnimation: function backgroundStopAnimation() {
          //zepto停止动画
          if ($.fx) {
            $.fx.off = true;
          }
          //获取当前页面内所有DB-ANIMATION并移除
          if (duibaPublic.animationElements) {
            duibaPublic.animationElements = $('.DB-ANIMATION');
            duibaPublic.animationElements.removeClass('DB-ANIMATION');
          }
          //app后台运行，把容器隐藏
          $('body').hide();
        },
        backgroundStartAnimation: function backgroundStartAnimation() {
          if (this.feizhuFlag) {
            setTimeout(function () {
              //重新添加DB-ANIMATION
              if (duibaPublic.animationElements) {
                duibaPublic.animationElements.addClass('DB-ANIMATION');
              }
              //开启zepto动画
              if ($.fx) {
                $.fx.off = false;
              }
            }, 1000);
          } else {
            //重新添加DB-ANIMATION
            if (duibaPublic.animationElements) {
              duibaPublic.animationElements.addClass('DB-ANIMATION');
            }
            //开启zepto动画
            if ($.fx) {
              $.fx.off = false;
            }
          }

          //重新展示被隐藏的容器
          $('body').show();
        },
        beforeInit: function beforeInit(initcallback) {
          //判断是否
          if (!window.backgroundFlag) {
            duibaPublic.initFlag = true;
            initcallback && initcallback();
          } else {
            duibaPublic.initFunction = initcallback;
          }
        }
      };

      window.duibaPublic = duibaPublic;
    }();
  }, { "../../components/recommendModal/index": 6, "../../requireStyle/3.0.0/requireStyle": 8, "../../showModal/1.0/showModal": 9 }], 8: [function (require, module, exports) {
    /**
     * @note    活动 - requireStyle 
     * @author  lijianbing <linjianbing@duiba.com.cn>
     * @create  17/01/13
     * @modify  17/01/13
     * @des     修改js端渲染方式
     */
    ;
    (function ($) {
      var defaultConfig, userConfig, StyleConfig, notWebp;

      var requireStyle = {
        /**
         * 初始化
         * @param  {[type]} options [description]
         * @return {[type]}         [description]
         */
        init: function init(options) {
          notWebp = options.notWebp;
          $.ajax({
            url: options.url,
            type: 'post',
            data: options.data,
            cache: false,
            dataType: 'json',
            success: function success(result) {
              if (result.success) {
                defaultConfig = result.defaultConfig;
                if (result.userConfig && result.userConfig.length != 0) {
                  userConfig = result.userConfig;
                  requireStyle.format();
                } else {
                  StyleConfig = $.extend(true, [], defaultConfig);
                }
                options.config && requireStyle.renderStyle(options.config);
                options.callback.success && options.callback.success(result);
              } else {
                options.callback.systemError && options.callback.systemError(result);
              }
            },
            error: function error() {
              options.callback.networkError && options.callback.networkError();
            }
          });
        },
        /**
         * 根据配置项name获取配置项的值
         * @param  {[type]} name [description]
         * @return {[type]}      [description]
         */
        getStyle: function getStyle(name) {
          for (var x in StyleConfig) {
            var tab = StyleConfig[x];
            for (var y in tab.childrens) {
              var child = tab.childrens[y];
              if (child.name == name) {
                return child.value;
              }
            }
          }
        },
        /**
         * 渲染配置项
         * @param  {[type]} param [description]
         * @return {[type]}       [description]
         */
        renderStyle: function renderStyle(param) {
          var styles = '';
          for (var i in param) {
            styles += requireStyle.setConfig(param[i][0], param[i][1], param[i][2]);
          }
          styles = '<style>' + styles + '</style>';
          $('head').append(styles);
        },
        /**
         * 根据配置项类型，生成对应的css
         * @param {[type]} element [description]
         * @param {[type]} type    [description]
         * @param {[type]} name    [description]
         */
        setConfig: function setConfig(element, type, name) {
          var style = '',
              _value = requireStyle.getStyle(name);
          if (_value) {
            switch (type) {
              case 'backgroundImage':
                if (typeof ''.ossimg === 'function' && !notWebp) {
                  _value = _value.ossimg();
                }
                style = element + '{background-image:url(' + _value + ') !important;}';
                break;
              case 'backgroundColor':
                style = element + '{background-color:' + _value + ' !important;}';
                break;
              case 'color':
                style = element + '{color:' + _value + ' !important;}';
                break;
              case 'borderColor':
                style = element + '{border-color:' + _value + ' !important;}';
                break;
              case 'html':
                $(element).html(_value);
                break;
              case 'image':
                if (typeof ''.ossimg === 'function' && !notWebp) {
                  _value = _value.ossimg();
                }
                $(element).attr('src', _value);
                break;
            }
          }
          return style;
        },

        format: function format() {
          /*检测默认配置中是否有新的配置项*/
          for (var x in defaultConfig) {
            var exist = false;
            var existTab;

            var tab = defaultConfig[x];
            for (var y in userConfig) {
              var DTab = userConfig[y];
              if (tab.name == DTab.name) {
                exist = true;
                existTab = DTab;
              }
            }
            if (exist) {
              for (var m in tab.childrens) {
                var exist = false;
                var existChild;
                for (var n in existTab.childrens) {
                  var child = tab.childrens[m];
                  var DChild = existTab.childrens[n];
                  if (child.name == DChild.name) {
                    exist = true;

                    /*
                     * 默认配置项有修改，以下参数以默认配置为准
                     * system:平台
                     * size:图片大小
                     * title:元素标题
                     */
                    if (child.system === undefined || child.system.length == 0) {
                      if (DChild.system !== undefined) {
                        delete DChild.system;
                      }
                    } else {
                      DChild.system = child.system;
                    }

                    DChild.title = child.title;

                    if (child.type == 'image') {
                      DChild.size = child.size;
                    }
                  }
                }
                if (!exist) {
                  existTab.childrens.push(child);
                }
              }
            } else {
              userConfig.push(tab);
            }
          }

          /*检测用户配置中是否有已废弃的配置项*/
          for (var x in userConfig) {
            var exist = false;
            var existTab;

            var tab = userConfig[x];
            for (var y in defaultConfig) {
              var DTab = defaultConfig[y];
              if (DTab.name == tab.name) {
                exist = true;
                existTab = DTab;
              }
            }
            if (exist) {
              for (var m in tab.childrens) {
                var exist = false;
                var existChild;
                for (var n in existTab.childrens) {

                  if (tab.childrens[m].name == existTab.childrens[n].name) {
                    exist = true;
                  }
                }
                if (!exist) {
                  tab.childrens.splice(m, 1);
                }
              }
            } else {
              userConfig.remove(tab);
            }
          }
          StyleConfig = $.extend(true, [], userConfig);
        }
      };

      window.requireStyle = requireStyle;
    })(Zepto);
  }, {}], 9: [function (require, module, exports) {
    (function ($) {
      require('../../components/recommendModal/gameover');
      var showModal = {
        show: function show(options) {
          var _defaults = {
            title: '', // 错误消息title
            tip: '', // 错误消息副标题
            type: '', // 错误消息类型
            btnText: '', // 按钮文案
            link: '', // 跳转链接
            needGameClose: true, // 是否需要游戏结束弹窗
            needOver: true, // 是否需要次数用完弹窗
            onClose: null, // 弹窗关闭的回调
            clickCallback: null // 弹窗按钮点击的回调
          };
          options = $.extend({}, _defaults, options);
          this.options = options;
          this.render(options);
        },
        hide: function hide() {
          $('.db-msg-modal').remove();
          $('#db-content').removeClass('filter');
          this.options.onClose && this.options.onClose();
          // 触发推荐位皮肤
          window.triggerRecommendSkin && window.triggerRecommendSkin();
        },
        render: function render(options) {
          if (options.type === 'gameClose' && options.needGameClose) {
            window.GameOverModal && window.GameOverModal.show(options);
            return false;
          }
          if ((options.type === 'over' || options.type === 'todayOver') && options.needOver) {
            window.recommendModal && window.recommendModal.show();
            return false;
          }
          var self = this,
              img = {
            again: '//yun.duiba.com.cn/h5/activity/showModal/1.0/again.png',
            noPrize: '//yun.duiba.com.cn/h5/activity/showModal/1.0/noPrize.png',
            todayOver: '//yun.duiba.com.cn/h5/activity/showModal/1.0/todayOver.png',
            over: '//yun.duiba.com.cn/h5/activity/showModal/1.0/over.png',
            noCredits: '//yun.duiba.com.cn/h5/activity/showModal/1.0/noCredits.png',
            noLogin: '//yun.duiba.com.cn/h5/activity/showModal/1.0/noLogin.png'
            // 'networkError': '//yun.duiba.com.cn/h5/activity/showModal/1.0/networkError.png'
          };
          var _image = img[options.type];
          _image = _image ? '<img src="' + _image + '" />' : '';
          var _html = '<div class="db-msg-modal">\n        <div class="msg-modal-wrapper">\n          <div class="msg-modal-header"> <i class="msg-modal-close"></i>\n            <h4 class="msg-title">' + options.title + '</h4>\n            <p class="msg-tip">' + options.tip + '</p>\n          </div>\n          <div class="msg-modal-section">' + _image + '</div>\n          <div class="msg-modal-footer">\n            <a href="javascript:;" class="msg-btn">' + options.btnText + '</a>\n          </div>\n        </div>\n      </div>';
          $('body').append(_html);
          $('#db-content').addClass('filter');

          $('.db-msg-modal').off('click').on('click', '.msg-modal-close', function () {
            if (options.type === 'tokenError') {
              setTimeout(function () {
                window.location.href = window.location.href;
              }, 100);
            } else {
              self.hide();
            }
          }).on('click', '.msg-btn', function () {
            if (options.type === 'tokenError') {
              setTimeout(function () {
                window.location.href = window.location.href;
              }, 100);
            } else {
              if (options.link) {
                window.location.href = options.link;
              }
              if (options.type === 'noLogin') {
                // 开发者配置的登录接口
                window.requirelogin && window.requirelogin();
                // 新埋点登录访问
                // window.loginExposure && window.loginExposure();
                window.duibaPublic && window.duibaPublic.loginExposure && window.duibaPublic.loginExposure();
              }
              options.clickCallback && options.clickCallback();
              self.hide();
            }
          });
        }
      };

      window.errorMsgModal = showModal;
    })(Zepto);
  }, { "../../components/recommendModal/gameover": 5 }], 10: [function (require, module, exports) {
    /**
     * 检查是否支持.webp 格式图片
     *
     * 支持 webp CDN   ?x-oss-process=image/format,webp
     * 不支持    CDN   ?x-oss-process=image/quality,Q_80
     */

    (function () {
      var urlarr = [];
      var flag = false,
          lowAdr = false; // 低版本安卓
      var ua = navigator.userAgent.toLowerCase();
      var isAndroid = ua.indexOf("android") > -1 || ua.indexOf("adr") > -1;
      if (isAndroid) {
        var ver = parseFloat(ua.substr(ua.indexOf("android") + 8, 3));
        lowAdr = ver < 4.4;
      }
      // 如果是低版本安卓，重新判断一下，修复之前的判断错误bug
      if (lowAdr && localStorage) {
        delete localStorage.iswebp;
      }
      if (localStorage && !localStorage.iswebp) {
        var img = new Image();
        img.onload = function () {
          if (img.width === 1 && !lowAdr) {
            localStorage.iswebp = true;
            document.getElementsByTagName("html")[0].setAttribute("duiba-webp", "true");
          } else {
            localStorage.iswebp = "";
          }
        };
        img.onerror = function () {
          flag = true;
          localStorage.iswebp = "";
        };
        img.src = "data:image/webp;base64,UklGRiQAAABXRUJQVlA4IBgAAAAwAQCdASoBAAEAAwA0JaQAA3AA/vuUAAA=";
      }

      function getOssImg(url) {
        if (!url) {
          return url;
        }
        if (!flag && localStorage && typeof localStorage.iswebp === "undefined") {
          getOssImg(url);
        } else {
          // gif 的图片不做处理
          urlarr = url.split(".");
          if (urlarr.length > 0 && urlarr[urlarr.length - 1] === "gif") {
            return url + "";
          }
          if (localStorage && localStorage.iswebp) {
            url = url + "?x-oss-process=image/format,webp";
          } else {
            url = url + "?x-oss-process=image/quality,Q_80";
          }
          return url;
        }
      }
      String.prototype.ossimg = function () {
        return getOssImg(this);
      };
      Array.prototype.imgWebpArray = function (key) {
        var array = [];
        var list = this;
        for (var i = 0; i < list.length; i++) {
          if (list[i][key]) {
            list[i][key] = list[i][key].ossimg();
            array.push(list[i]);
          }
        }
        return array;
      };
    })();
  }, {}], 11: [function (require, module, exports) {
    /**
     * @desc    cookie 
     * @author  朱双龙 <zsl@duiba.com.cn>
     * @date    2016-07-25
     */

    $.cookie = function (a, b, c) {
      if ("undefined" == typeof b) {
        var d = null;if (document.cookie && "" != document.cookie) for (var e = document.cookie.split(";"), f = 0; f < e.length; f++) {
          var g = $.trim(e[f]);if (g.substring(0, a.length + 1) == a + "=") {
            d = decodeURIComponent(g.substring(a.length + 1));break;
          }
        }return d;
      }c = c || {}, null === b && (b = "", c = $.extend({}, c), c.expires = -1);var h = "";if (c.expires && ("number" == typeof c.expires || c.expires.toUTCString)) {
        var i;"number" == typeof c.expires ? (i = new Date(), i.setTime(i.getTime() + 24 * c.expires * 60 * 60 * 1e3)) : i = c.expires, h = "; expires=" + i.toUTCString();
      }var j = c.path ? "; path=" + c.path : "",
          k = c.domain ? "; domain=" + c.domain : "",
          l = c.secure ? "; secure" : "";document.cookie = [a, "=", encodeURIComponent(b), h, j, k, l].join("");
    };
  }, {}], 12: [function (require, module, exports) {
    var _typeof = typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol" ? function (obj) {
      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
    } : function (obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
    };

    ;(function () {
      'use strict';

      /**
       * @preserve FastClick: polyfill to remove click delays on browsers with touch UIs.
       *
       * @codingstandard ftlabs-jsv2
       * @copyright The Financial Times Limited [All Rights Reserved]
       * @license MIT License (see LICENSE.txt)
       */

      /*jslint browser:true, node:true*/
      /*global define, Event, Node*/

      /**
       * Instantiate fast-clicking listeners on the specified layer.
       *
       * @constructor
       * @param {Element} layer The layer to listen on
       * @param {Object} [options={}] The options to override the defaults
       */

      function FastClick(layer, options) {
        var oldOnClick;

        options = options || {};

        /**
         * Whether a click is currently being tracked.
         *
         * @type boolean
         */
        this.trackingClick = false;

        /**
         * Timestamp for when click tracking started.
         *
         * @type number
         */
        this.trackingClickStart = 0;

        /**
         * The element being tracked for a click.
         *
         * @type EventTarget
         */
        this.targetElement = null;

        /**
         * X-coordinate of touch start event.
         *
         * @type number
         */
        this.touchStartX = 0;

        /**
         * Y-coordinate of touch start event.
         *
         * @type number
         */
        this.touchStartY = 0;

        /**
         * ID of the last touch, retrieved from Touch.identifier.
         *
         * @type number
         */
        this.lastTouchIdentifier = 0;

        /**
         * Touchmove boundary, beyond which a click will be cancelled.
         *
         * @type number
         */
        this.touchBoundary = options.touchBoundary || 10;

        /**
         * The FastClick layer.
         *
         * @type Element
         */
        this.layer = layer;

        /**
         * The minimum time between tap(touchstart and touchend) events
         *
         * @type number
         */
        this.tapDelay = options.tapDelay || 200;

        /**
         * The maximum time for a tap
         *
         * @type number
         */
        this.tapTimeout = options.tapTimeout || 700;

        if (FastClick.notNeeded(layer)) {
          return;
        }

        // Some old versions of Android don't have Function.prototype.bind
        function bind(method, context) {
          return function () {
            return method.apply(context, arguments);
          };
        }

        var methods = ['onMouse', 'onClick', 'onTouchStart', 'onTouchMove', 'onTouchEnd', 'onTouchCancel'];
        var context = this;
        for (var i = 0, l = methods.length; i < l; i++) {
          context[methods[i]] = bind(context[methods[i]], context);
        }

        // Set up event handlers as required
        if (deviceIsAndroid) {
          layer.addEventListener('mouseover', this.onMouse, true);
          layer.addEventListener('mousedown', this.onMouse, true);
          layer.addEventListener('mouseup', this.onMouse, true);
        }

        layer.addEventListener('click', this.onClick, true);
        layer.addEventListener('touchstart', this.onTouchStart, false);
        layer.addEventListener('touchmove', this.onTouchMove, false);
        layer.addEventListener('touchend', this.onTouchEnd, false);
        layer.addEventListener('touchcancel', this.onTouchCancel, false);

        // Hack is required for browsers that don't support Event#stopImmediatePropagation (e.g. Android 2)
        // which is how FastClick normally stops click events bubbling to callbacks registered on the FastClick
        // layer when they are cancelled.
        if (!Event.prototype.stopImmediatePropagation) {
          layer.removeEventListener = function (type, callback, capture) {
            var rmv = Node.prototype.removeEventListener;
            if (type === 'click') {
              rmv.call(layer, type, callback.hijacked || callback, capture);
            } else {
              rmv.call(layer, type, callback, capture);
            }
          };

          layer.addEventListener = function (type, callback, capture) {
            var adv = Node.prototype.addEventListener;
            if (type === 'click') {
              adv.call(layer, type, callback.hijacked || (callback.hijacked = function (event) {
                if (!event.propagationStopped) {
                  callback(event);
                }
              }), capture);
            } else {
              adv.call(layer, type, callback, capture);
            }
          };
        }

        // If a handler is already declared in the element's onclick attribute, it will be fired before
        // FastClick's onClick handler. Fix this by pulling out the user-defined handler function and
        // adding it as listener.
        if (typeof layer.onclick === 'function') {

          // Android browser on at least 3.2 requires a new reference to the function in layer.onclick
          // - the old one won't work if passed to addEventListener directly.
          oldOnClick = layer.onclick;
          layer.addEventListener('click', function (event) {
            oldOnClick(event);
          }, false);
          layer.onclick = null;
        }
      }

      /**
      * Windows Phone 8.1 fakes user agent string to look like Android and iPhone.
      *
      * @type boolean
      */
      var deviceIsWindowsPhone = navigator.userAgent.indexOf("Windows Phone") >= 0;

      /**
       * Android requires exceptions.
       *
       * @type boolean
       */
      var deviceIsAndroid = navigator.userAgent.indexOf('Android') > 0 && !deviceIsWindowsPhone;

      /**
       * iOS requires exceptions.
       *
       * @type boolean
       */
      var deviceIsIOS = /iP(ad|hone|od)/.test(navigator.userAgent) && !deviceIsWindowsPhone;

      /**
       * iOS 4 requires an exception for select elements.
       *
       * @type boolean
       */
      var deviceIsIOS4 = deviceIsIOS && /OS 4_\d(_\d)?/.test(navigator.userAgent);

      /**
       * iOS 6.0-7.* requires the target element to be manually derived
       *
       * @type boolean
       */
      var deviceIsIOSWithBadTarget = deviceIsIOS && /OS [6-7]_\d/.test(navigator.userAgent);

      /**
       * BlackBerry requires exceptions.
       *
       * @type boolean
       */
      var deviceIsBlackBerry10 = navigator.userAgent.indexOf('BB10') > 0;

      /**
       * Determine whether a given element requires a native click.
       *
       * @param {EventTarget|Element} target Target DOM element
       * @returns {boolean} Returns true if the element needs a native click
       */
      FastClick.prototype.needsClick = function (target) {
        switch (target.nodeName.toLowerCase()) {

          // Don't send a synthetic click to disabled inputs (issue #62)
          case 'button':
          case 'select':
          case 'textarea':
            if (target.disabled) {
              return true;
            }

            break;
          case 'input':

            // File inputs need real clicks on iOS 6 due to a browser bug (issue #68)
            if (deviceIsIOS && target.type === 'file' || target.disabled) {
              return true;
            }

            break;
          case 'label':
          case 'iframe': // iOS8 homescreen apps can prevent events bubbling into frames
          case 'video':
            return true;
        }

        return (/\bneedsclick\b/.test(target.className)
        );
      };

      /**
       * Determine whether a given element requires a call to focus to simulate click into element.
       *
       * @param {EventTarget|Element} target Target DOM element
       * @returns {boolean} Returns true if the element requires a call to focus to simulate native click.
       */
      FastClick.prototype.needsFocus = function (target) {
        switch (target.nodeName.toLowerCase()) {
          case 'textarea':
            return true;
          case 'select':
            return !deviceIsAndroid;
          case 'input':
            switch (target.type) {
              case 'button':
              case 'checkbox':
              case 'file':
              case 'image':
              case 'radio':
              case 'submit':
                return false;
            }

            // No point in attempting to focus disabled inputs
            return !target.disabled && !target.readOnly;
          default:
            return (/\bneedsfocus\b/.test(target.className)
            );
        }
      };

      /**
       * Send a click event to the specified element.
       *
       * @param {EventTarget|Element} targetElement
       * @param {Event} event
       */
      FastClick.prototype.sendClick = function (targetElement, event) {
        var clickEvent, touch;

        // On some Android devices activeElement needs to be blurred otherwise the synthetic click will have no effect (#24)
        if (document.activeElement && document.activeElement !== targetElement) {
          document.activeElement.blur();
        }

        touch = event.changedTouches[0];

        // Synthesise a click event, with an extra attribute so it can be tracked
        clickEvent = document.createEvent('MouseEvents');
        clickEvent.initMouseEvent(this.determineEventType(targetElement), true, true, window, 1, touch.screenX, touch.screenY, touch.clientX, touch.clientY, false, false, false, false, 0, null);
        clickEvent.forwardedTouchEvent = true;
        targetElement.dispatchEvent(clickEvent);
      };

      FastClick.prototype.determineEventType = function (targetElement) {

        //Issue #159: Android Chrome Select Box does not open with a synthetic click event
        if (deviceIsAndroid && targetElement.tagName.toLowerCase() === 'select') {
          return 'mousedown';
        }

        return 'click';
      };

      /**
       * @param {EventTarget|Element} targetElement
       */
      FastClick.prototype.focus = function (targetElement) {
        var length;

        // Issue #160: on iOS 7, some input elements (e.g. date datetime month) throw a vague TypeError on setSelectionRange. These elements don't have an integer value for the selectionStart and selectionEnd properties, but unfortunately that can't be used for detection because accessing the properties also throws a TypeError. Just check the type instead. Filed as Apple bug #15122724.
        if (deviceIsIOS && targetElement.setSelectionRange && targetElement.type.indexOf('date') !== 0 && targetElement.type !== 'time' && targetElement.type !== 'month') {
          length = targetElement.value.length;
          targetElement.setSelectionRange(length, length);
        } else {
          targetElement.focus();
        }
      };

      /**
       * Check whether the given target element is a child of a scrollable layer and if so, set a flag on it.
       *
       * @param {EventTarget|Element} targetElement
       */
      FastClick.prototype.updateScrollParent = function (targetElement) {
        var scrollParent, parentElement;

        scrollParent = targetElement.fastClickScrollParent;

        // Attempt to discover whether the target element is contained within a scrollable layer. Re-check if the
        // target element was moved to another parent.
        if (!scrollParent || !scrollParent.contains(targetElement)) {
          parentElement = targetElement;
          do {
            if (parentElement.scrollHeight > parentElement.offsetHeight) {
              scrollParent = parentElement;
              targetElement.fastClickScrollParent = parentElement;
              break;
            }

            parentElement = parentElement.parentElement;
          } while (parentElement);
        }

        // Always update the scroll top tracker if possible.
        if (scrollParent) {
          scrollParent.fastClickLastScrollTop = scrollParent.scrollTop;
        }
      };

      /**
       * @param {EventTarget} targetElement
       * @returns {Element|EventTarget}
       */
      FastClick.prototype.getTargetElementFromEventTarget = function (eventTarget) {

        // On some older browsers (notably Safari on iOS 4.1 - see issue #56) the event target may be a text node.
        if (eventTarget.nodeType === Node.TEXT_NODE) {
          return eventTarget.parentNode;
        }

        return eventTarget;
      };

      /**
       * On touch start, record the position and scroll offset.
       *
       * @param {Event} event
       * @returns {boolean}
       */
      FastClick.prototype.onTouchStart = function (event) {
        var targetElement, touch, selection;

        // Ignore multiple touches, otherwise pinch-to-zoom is prevented if both fingers are on the FastClick element (issue #111).
        if (event.targetTouches.length > 1) {
          return true;
        }

        targetElement = this.getTargetElementFromEventTarget(event.target);
        touch = event.targetTouches[0];

        if (deviceIsIOS) {

          // Only trusted events will deselect text on iOS (issue #49)
          selection = window.getSelection();
          if (selection.rangeCount && !selection.isCollapsed) {
            return true;
          }

          if (!deviceIsIOS4) {

            // Weird things happen on iOS when an alert or confirm dialog is opened from a click event callback (issue #23):
            // when the user next taps anywhere else on the page, new touchstart and touchend events are dispatched
            // with the same identifier as the touch event that previously triggered the click that triggered the alert.
            // Sadly, there is an issue on iOS 4 that causes some normal touch events to have the same identifier as an
            // immediately preceeding touch event (issue #52), so this fix is unavailable on that platform.
            // Issue 120: touch.identifier is 0 when Chrome dev tools 'Emulate touch events' is set with an iOS device UA string,
            // which causes all touch events to be ignored. As this block only applies to iOS, and iOS identifiers are always long,
            // random integers, it's safe to to continue if the identifier is 0 here.
            if (touch.identifier && touch.identifier === this.lastTouchIdentifier) {
              event.preventDefault();
              return false;
            }

            this.lastTouchIdentifier = touch.identifier;

            // If the target element is a child of a scrollable layer (using -webkit-overflow-scrolling: touch) and:
            // 1) the user does a fling scroll on the scrollable layer
            // 2) the user stops the fling scroll with another tap
            // then the event.target of the last 'touchend' event will be the element that was under the user's finger
            // when the fling scroll was started, causing FastClick to send a click event to that layer - unless a check
            // is made to ensure that a parent layer was not scrolled before sending a synthetic click (issue #42).
            this.updateScrollParent(targetElement);
          }
        }

        this.trackingClick = true;
        this.trackingClickStart = event.timeStamp;
        this.targetElement = targetElement;

        this.touchStartX = touch.pageX;
        this.touchStartY = touch.pageY;

        // Prevent phantom clicks on fast double-tap (issue #36)
        if (event.timeStamp - this.lastClickTime < this.tapDelay) {
          event.preventDefault();
        }

        return true;
      };

      /**
       * Based on a touchmove event object, check whether the touch has moved past a boundary since it started.
       *
       * @param {Event} event
       * @returns {boolean}
       */
      FastClick.prototype.touchHasMoved = function (event) {
        var touch = event.changedTouches[0],
            boundary = this.touchBoundary;

        if (Math.abs(touch.pageX - this.touchStartX) > boundary || Math.abs(touch.pageY - this.touchStartY) > boundary) {
          return true;
        }

        return false;
      };

      /**
       * Update the last position.
       *
       * @param {Event} event
       * @returns {boolean}
       */
      FastClick.prototype.onTouchMove = function (event) {
        if (!this.trackingClick) {
          return true;
        }

        // If the touch has moved, cancel the click tracking
        if (this.targetElement !== this.getTargetElementFromEventTarget(event.target) || this.touchHasMoved(event)) {
          this.trackingClick = false;
          this.targetElement = null;
        }

        return true;
      };

      /**
       * Attempt to find the labelled control for the given label element.
       *
       * @param {EventTarget|HTMLLabelElement} labelElement
       * @returns {Element|null}
       */
      FastClick.prototype.findControl = function (labelElement) {

        // Fast path for newer browsers supporting the HTML5 control attribute
        if (labelElement.control !== undefined) {
          return labelElement.control;
        }

        // All browsers under test that support touch events also support the HTML5 htmlFor attribute
        if (labelElement.htmlFor) {
          return document.getElementById(labelElement.htmlFor);
        }

        // If no for attribute exists, attempt to retrieve the first labellable descendant element
        // the list of which is defined here: http://www.w3.org/TR/html5/forms.html#category-label
        return labelElement.querySelector('button, input:not([type=hidden]), keygen, meter, output, progress, select, textarea');
      };

      /**
       * On touch end, determine whether to send a click event at once.
       *
       * @param {Event} event
       * @returns {boolean}
       */
      FastClick.prototype.onTouchEnd = function (event) {
        var forElement,
            trackingClickStart,
            targetTagName,
            scrollParent,
            touch,
            targetElement = this.targetElement;

        if (!this.trackingClick) {
          return true;
        }

        // Prevent phantom clicks on fast double-tap (issue #36)
        if (event.timeStamp - this.lastClickTime < this.tapDelay) {
          this.cancelNextClick = true;
          return true;
        }

        if (event.timeStamp - this.trackingClickStart > this.tapTimeout) {
          return true;
        }

        // Reset to prevent wrong click cancel on input (issue #156).
        this.cancelNextClick = false;

        this.lastClickTime = event.timeStamp;

        trackingClickStart = this.trackingClickStart;
        this.trackingClick = false;
        this.trackingClickStart = 0;

        // On some iOS devices, the targetElement supplied with the event is invalid if the layer
        // is performing a transition or scroll, and has to be re-detected manually. Note that
        // for this to function correctly, it must be called *after* the event target is checked!
        // See issue #57; also filed as rdar://13048589 .
        if (deviceIsIOSWithBadTarget) {
          touch = event.changedTouches[0];

          // In certain cases arguments of elementFromPoint can be negative, so prevent setting targetElement to null
          targetElement = document.elementFromPoint(touch.pageX - window.pageXOffset, touch.pageY - window.pageYOffset) || targetElement;
          targetElement.fastClickScrollParent = this.targetElement.fastClickScrollParent;
        }

        targetTagName = targetElement.tagName.toLowerCase();
        if (targetTagName === 'label') {
          forElement = this.findControl(targetElement);
          if (forElement) {
            this.focus(targetElement);
            if (deviceIsAndroid) {
              return false;
            }

            targetElement = forElement;
          }
        } else if (this.needsFocus(targetElement)) {

          // Case 1: If the touch started a while ago (best guess is 100ms based on tests for issue #36) then focus will be triggered anyway. Return early and unset the target element reference so that the subsequent click will be allowed through.
          // Case 2: Without this exception for input elements tapped when the document is contained in an iframe, then any inputted text won't be visible even though the value attribute is updated as the user types (issue #37).
          if (event.timeStamp - trackingClickStart > 100 || deviceIsIOS && window.top !== window && targetTagName === 'input') {
            this.targetElement = null;
            return false;
          }

          this.focus(targetElement);
          this.sendClick(targetElement, event);

          // Select elements need the event to go through on iOS 4, otherwise the selector menu won't open.
          // Also this breaks opening selects when VoiceOver is active on iOS6, iOS7 (and possibly others)
          if (!deviceIsIOS || targetTagName !== 'select') {
            this.targetElement = null;
            event.preventDefault();
          }

          return false;
        }

        if (deviceIsIOS && !deviceIsIOS4) {

          // Don't send a synthetic click event if the target element is contained within a parent layer that was scrolled
          // and this tap is being used to stop the scrolling (usually initiated by a fling - issue #42).
          scrollParent = targetElement.fastClickScrollParent;
          if (scrollParent && scrollParent.fastClickLastScrollTop !== scrollParent.scrollTop) {
            return true;
          }
        }

        // Prevent the actual click from going though - unless the target node is marked as requiring
        // real clicks or if it is in the whitelist in which case only non-programmatic clicks are permitted.
        if (!this.needsClick(targetElement)) {
          event.preventDefault();
          this.sendClick(targetElement, event);
        }

        return false;
      };

      /**
       * On touch cancel, stop tracking the click.
       *
       * @returns {void}
       */
      FastClick.prototype.onTouchCancel = function () {
        this.trackingClick = false;
        this.targetElement = null;
      };

      /**
       * Determine mouse events which should be permitted.
       *
       * @param {Event} event
       * @returns {boolean}
       */
      FastClick.prototype.onMouse = function (event) {

        // If a target element was never set (because a touch event was never fired) allow the event
        if (!this.targetElement) {
          return true;
        }

        if (event.forwardedTouchEvent) {
          return true;
        }

        // Programmatically generated events targeting a specific element should be permitted
        if (!event.cancelable) {
          return true;
        }

        // Derive and check the target element to see whether the mouse event needs to be permitted;
        // unless explicitly enabled, prevent non-touch click events from triggering actions,
        // to prevent ghost/doubleclicks.
        if (!this.needsClick(this.targetElement) || this.cancelNextClick) {

          // Prevent any user-added listeners declared on FastClick element from being fired.
          if (event.stopImmediatePropagation) {
            event.stopImmediatePropagation();
          } else {

            // Part of the hack for browsers that don't support Event#stopImmediatePropagation (e.g. Android 2)
            event.propagationStopped = true;
          }

          // Cancel the event
          event.stopPropagation();
          event.preventDefault();

          return false;
        }

        // If the mouse event is permitted, return true for the action to go through.
        return true;
      };

      /**
       * On actual clicks, determine whether this is a touch-generated click, a click action occurring
       * naturally after a delay after a touch (which needs to be cancelled to avoid duplication), or
       * an actual click which should be permitted.
       *
       * @param {Event} event
       * @returns {boolean}
       */
      FastClick.prototype.onClick = function (event) {
        var permitted;

        // It's possible for another FastClick-like library delivered with third-party code to fire a click event before FastClick does (issue #44). In that case, set the click-tracking flag back to false and return early. This will cause onTouchEnd to return early.
        if (this.trackingClick) {
          this.targetElement = null;
          this.trackingClick = false;
          return true;
        }

        // Very odd behaviour on iOS (issue #18): if a submit element is present inside a form and the user hits enter in the iOS simulator or clicks the Go button on the pop-up OS keyboard the a kind of 'fake' click event will be triggered with the submit-type input element as the target.
        if (event.target.type === 'submit' && event.detail === 0) {
          return true;
        }

        permitted = this.onMouse(event);

        // Only unset targetElement if the click is not permitted. This will ensure that the check for !targetElement in onMouse fails and the browser's click doesn't go through.
        if (!permitted) {
          this.targetElement = null;
        }

        // If clicks are permitted, return true for the action to go through.
        return permitted;
      };

      /**
       * Remove all FastClick's event listeners.
       *
       * @returns {void}
       */
      FastClick.prototype.destroy = function () {
        var layer = this.layer;

        if (deviceIsAndroid) {
          layer.removeEventListener('mouseover', this.onMouse, true);
          layer.removeEventListener('mousedown', this.onMouse, true);
          layer.removeEventListener('mouseup', this.onMouse, true);
        }

        layer.removeEventListener('click', this.onClick, true);
        layer.removeEventListener('touchstart', this.onTouchStart, false);
        layer.removeEventListener('touchmove', this.onTouchMove, false);
        layer.removeEventListener('touchend', this.onTouchEnd, false);
        layer.removeEventListener('touchcancel', this.onTouchCancel, false);
      };

      /**
       * Check whether FastClick is needed.
       *
       * @param {Element} layer The layer to listen on
       */
      FastClick.notNeeded = function (layer) {
        var metaViewport;
        var chromeVersion;
        var blackberryVersion;
        var firefoxVersion;

        // Devices that don't support touch don't need FastClick
        if (typeof window.ontouchstart === 'undefined') {
          return true;
        }

        // Chrome version - zero for other browsers
        chromeVersion = +(/Chrome\/([0-9]+)/.exec(navigator.userAgent) || [, 0])[1];

        if (chromeVersion) {

          if (deviceIsAndroid) {
            metaViewport = document.querySelector('meta[name=viewport]');

            if (metaViewport) {
              // Chrome on Android with user-scalable="no" doesn't need FastClick (issue #89)
              if (metaViewport.content.indexOf('user-scalable=no') !== -1) {
                return true;
              }
              // Chrome 32 and above with width=device-width or less don't need FastClick
              if (chromeVersion > 31 && document.documentElement.scrollWidth <= window.outerWidth) {
                return true;
              }
            }

            // Chrome desktop doesn't need FastClick (issue #15)
          } else {
            return true;
          }
        }

        if (deviceIsBlackBerry10) {
          blackberryVersion = navigator.userAgent.match(/Version\/([0-9]*)\.([0-9]*)/);

          // BlackBerry 10.3+ does not require Fastclick library.
          // https://github.com/ftlabs/fastclick/issues/251
          if (blackberryVersion[1] >= 10 && blackberryVersion[2] >= 3) {
            metaViewport = document.querySelector('meta[name=viewport]');

            if (metaViewport) {
              // user-scalable=no eliminates click delay.
              if (metaViewport.content.indexOf('user-scalable=no') !== -1) {
                return true;
              }
              // width=device-width (or less than device-width) eliminates click delay.
              if (document.documentElement.scrollWidth <= window.outerWidth) {
                return true;
              }
            }
          }
        }

        // IE10 with -ms-touch-action: none or manipulation, which disables double-tap-to-zoom (issue #97)
        if (layer.style.msTouchAction === 'none' || layer.style.touchAction === 'manipulation') {
          return true;
        }

        // Firefox version - zero for other browsers
        firefoxVersion = +(/Firefox\/([0-9]+)/.exec(navigator.userAgent) || [, 0])[1];

        if (firefoxVersion >= 27) {
          // Firefox 27+ does not have tap delay if the content is not zoomable - https://bugzilla.mozilla.org/show_bug.cgi?id=922896

          metaViewport = document.querySelector('meta[name=viewport]');
          if (metaViewport && (metaViewport.content.indexOf('user-scalable=no') !== -1 || document.documentElement.scrollWidth <= window.outerWidth)) {
            return true;
          }
        }

        // IE11: prefixed -ms-touch-action is no longer supported and it's recomended to use non-prefixed version
        // http://msdn.microsoft.com/en-us/library/windows/apps/Hh767313.aspx
        if (layer.style.touchAction === 'none' || layer.style.touchAction === 'manipulation') {
          return true;
        }

        return false;
      };

      /**
       * Factory method for creating a FastClick object
       *
       * @param {Element} layer The layer to listen on
       * @param {Object} [options={}] The options to override the defaults
       */
      FastClick.attach = function (layer, options) {
        return new FastClick(layer, options);
      };

      if (typeof define === 'function' && _typeof(define.amd) === 'object' && define.amd) {

        // AMD. Register as an anonymous module.
        define(function () {
          return FastClick;
        });
      } else if (typeof module !== 'undefined' && module.exports) {
        module.exports = FastClick.attach;
        module.exports.FastClick = FastClick;
      } else {
        window.FastClick = FastClick;
      }
    })();
  }, {}], 13: [function (require, module, exports) {
    /**
     * @preserve Tiny-Loader: A small loader that load CSS/JS in best way for page performanceIs.
     *
     * @version 1.0.1
     * @copyright The Youzan Limited [All Rights Reserved]
     * @license MIT License (see LICENSE.txt)
     */
    (function (window, document) {
      'use strict';
      // cssExpr 用于判断资源是否是css

      var cssExpr = new RegExp('\\.css|.less');
      var nHead = document.head || document.getElementsByTagName('head')[0];
      // `onload` 在WebKit < 535.23， Firefox < 9.0 不被支持
      var isOldWebKit = +navigator.userAgent.replace(/.*(?:AppleWebKit|AndroidWebKit)\/?(\d+).*/i, '$1') < 536;

      // 判断对应的node节点是否已经载入完成
      function isReady(node) {
        return node.readyState === 'complete' || node.readyState === 'loaded';
      }

      // loadCss 用于载入css资源
      function loadCss(url, setting, callback) {
        var node = document.createElement('link');

        node.rel = 'stylesheet';
        addOnload(node, callback, 'css');
        node.async = true;
        node.href = url;

        nHead.appendChild(node);
      }

      // loadJs 用于载入js资源
      function loadJs(url, setting, callback) {
        var node = document.createElement('script');

        node.charset = 'utf-8';
        addOnload(node, callback, 'js');
        node.async = !setting.sync;
        node.crossOrigin = 'anonymous';
        node.src = url;

        nHead.appendChild(node);
      }

      // 在老的webkit中，因不支持load事件，这里用轮询sheet来保证
      function pollCss(node, callback) {
        var isLoaded;

        if (node.sheet) {
          isLoaded = true;
        }

        setTimeout(function () {
          if (isLoaded) {
            // 在这里callback 是为了让样式有足够的时间渲染
            callback();
          } else {
            pollCss(node, callback);
          }
        }, 20);
      }

      // 用于给指定的节点绑定onload回调
      // 监听元素载入完成事件
      function addOnload(node, callback, type) {
        var supportOnload = 'onload' in node;
        var isCSS = type === 'css';

        // 对老的webkit和老的firefox的兼容
        if (isCSS && (isOldWebKit || !supportOnload)) {
          setTimeout(function () {
            pollCss(node, callback);
          }, 1);
          return;
        }

        if (supportOnload) {
          node.onload = onload;
          node.onerror = function () {
            node.onerror = null;
            window._cdnFallback(node);
          };
        } else {
          node.onreadystatechange = function () {
            if (isReady(node)) {
              onload();
            }
          };
        }

        function onload() {
          // 执行一次后清除，防止重复执行
          node.onload = node.onreadystatechange = null;

          node = null;

          callback();
        }
      }

      // 资源下载入口，根绝文件类型的不同，调用loadCss或者loadJs
      function loadItem(url, list, setting, callback) {
        if (cssExpr.test(url)) {
          loadCss(url, setting, onFinishLoading);
        } else {
          loadJs(url, setting, onFinishLoading);
        }

        // 每次资源下载完成后，检验是否结束整个list下载过程
        // 若已经完成所有下载，执行回调函数
        function onFinishLoading() {
          var urlIndex = list.indexOf(url);
          if (urlIndex > -1) {
            list.splice(urlIndex, 1);
          }

          if (list.length === 0) {
            callback();
          }
        }
      }

      function doInit(list, setting, callback) {
        var cb = function cb() {
          callback && callback();
        };

        list = Array.prototype.slice.call(list || []);

        if (list.length === 0) {
          cb();
          return;
        }

        for (var i = 0, len = list.length; i < len; i++) {
          loadItem(list[i], list, setting, cb);
        }
      }

      // 判断当前页面是否加载完
      // 加载完，立刻执行下载
      // 未加载完，等待页面load事件以后再进行下载
      function ready(node, callback) {
        if (isReady(node)) {
          callback();
        } else {
          window.addEventListener('load', callback);
        }
      }

      // 暴露出去的Loader
      // 提供async, sync两个函数
      // async 用作异步下载执行用，不阻塞页面渲染
      // sync  用作异步下载，顺序执行，保证下载的js按照数组顺序执行
      var Loader = {
        async: function async(list, callback) {
          ready(document, function () {
            doInit(list, {}, callback);
          });
        },

        sync: function sync(list, callback) {
          ready(document, function () {
            doInit(list, {
              sync: true
            }, callback);
          });
        }
      };

      window.Loader = Loader;

      return Loader;
    })(window, document);
  }, {}], 14: [function (require, module, exports) {
    var _typeof = typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol" ? function (obj) {
      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
    } : function (obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
    };

    // Zepto 1.1.4 (generated with Zepto Builder) - zepto event ajax form ie selector - zeptojs.com/license 
    var Zepto = function () {
      function t(t) {
        return null == t ? t + "" : U[J.call(t)] || "object";
      }function e(e) {
        return "function" == t(e);
      }function n(t) {
        return null != t && t == t.window;
      }function r(t) {
        return null != t && t.nodeType == t.DOCUMENT_NODE;
      }function i(e) {
        return "object" == t(e);
      }function o(t) {
        return i(t) && !n(t) && Object.getPrototypeOf(t) == Object.prototype;
      }function s(t) {
        return "number" == typeof t.length;
      }function a(t) {
        return P.call(t, function (t) {
          return null != t;
        });
      }function u(t) {
        return t.length > 0 ? j.fn.concat.apply([], t) : t;
      }function c(t) {
        return t.replace(/::/g, "/").replace(/([A-Z]+)([A-Z][a-z])/g, "$1_$2").replace(/([a-z\d])([A-Z])/g, "$1_$2").replace(/_/g, "-").toLowerCase();
      }function l(t) {
        return t in $ ? $[t] : $[t] = RegExp("(^|\\s)" + t + "(\\s|$)");
      }function f(t, e) {
        return "number" != typeof e || L[c(t)] ? e : e + "px";
      }function h(t) {
        var e, n;return Z[t] || (e = A.createElement(t), A.body.appendChild(e), n = getComputedStyle(e, "").getPropertyValue("display"), e.parentNode.removeChild(e), "none" == n && (n = "block"), Z[t] = n), Z[t];
      }function p(t) {
        return "children" in t ? O.call(t.children) : j.map(t.childNodes, function (t) {
          return 1 == t.nodeType ? t : w;
        });
      }function d(t, e, n) {
        for (E in e) {
          n && (o(e[E]) || G(e[E])) ? (o(e[E]) && !o(t[E]) && (t[E] = {}), G(e[E]) && !G(t[E]) && (t[E] = []), d(t[E], e[E], n)) : e[E] !== w && (t[E] = e[E]);
        }
      }function m(t, e) {
        return null == e ? j(t) : j(t).filter(e);
      }function v(t, n, r, i) {
        return e(n) ? n.call(t, r, i) : n;
      }function g(t, e, n) {
        null == n ? t.removeAttribute(e) : t.setAttribute(e, n);
      }function y(t, e) {
        var n = t.className || "",
            r = n && n.baseVal !== w;return e === w ? r ? n.baseVal : n : (r ? n.baseVal = e : t.className = e, w);
      }function x(t) {
        var e;try {
          return t ? "true" == t || ("false" == t ? !1 : "null" == t ? null : /^0/.test(t) || isNaN(e = Number(t)) ? /^[\[\{]/.test(t) ? j.parseJSON(t) : t : e) : t;
        } catch (n) {
          return t;
        }
      }function b(t, e) {
        e(t);for (var n = 0, r = t.childNodes.length; r > n; n++) {
          b(t.childNodes[n], e);
        }
      }var w,
          E,
          j,
          N,
          C,
          T,
          S = [],
          O = S.slice,
          P = S.filter,
          A = window.document,
          Z = {},
          $ = {},
          L = { "column-count": 1, columns: 1, "font-weight": 1, "line-height": 1, opacity: 1, "z-index": 1, zoom: 1 },
          _ = /^\s*<(\w+|!)[^>]*>/,
          D = /^<(\w+)\s*\/?>(?:<\/\1>|)$/,
          R = /<(?!area|br|col|embed|hr|img|input|link|meta|param)(([\w:]+)[^>]*)\/>/gi,
          k = /^(?:body|html)$/i,
          q = /([A-Z])/g,
          M = ["val", "css", "html", "text", "data", "width", "height", "offset"],
          z = ["after", "prepend", "before", "append"],
          F = A.createElement("table"),
          H = A.createElement("tr"),
          I = { tr: A.createElement("tbody"), tbody: F, thead: F, tfoot: F, td: H, th: H, "*": A.createElement("div") },
          V = /complete|loaded|interactive/,
          B = /^[\w-]*$/,
          U = {},
          J = U.toString,
          X = {},
          W = A.createElement("div"),
          Y = { tabindex: "tabIndex", readonly: "readOnly", "for": "htmlFor", "class": "className", maxlength: "maxLength", cellspacing: "cellSpacing", cellpadding: "cellPadding", rowspan: "rowSpan", colspan: "colSpan", usemap: "useMap", frameborder: "frameBorder", contenteditable: "contentEditable" },
          G = Array.isArray || function (t) {
        return t instanceof Array;
      };return X.matches = function (t, e) {
        if (!e || !t || 1 !== t.nodeType) return !1;var n = t.webkitMatchesSelector || t.mozMatchesSelector || t.oMatchesSelector || t.matchesSelector;if (n) return n.call(t, e);var r,
            i = t.parentNode,
            o = !i;return o && (i = W).appendChild(t), r = ~X.qsa(i, e).indexOf(t), o && W.removeChild(t), r;
      }, C = function C(t) {
        return t.replace(/-+(.)?/g, function (t, e) {
          return e ? e.toUpperCase() : "";
        });
      }, T = function T(t) {
        return P.call(t, function (e, n) {
          return t.indexOf(e) == n;
        });
      }, X.fragment = function (t, e, n) {
        var r, i, s;return D.test(t) && (r = j(A.createElement(RegExp.$1))), r || (t.replace && (t = t.replace(R, "<$1></$2>")), e === w && (e = _.test(t) && RegExp.$1), e in I || (e = "*"), s = I[e], s.innerHTML = "" + t, r = j.each(O.call(s.childNodes), function () {
          s.removeChild(this);
        })), o(n) && (i = j(r), j.each(n, function (t, e) {
          M.indexOf(t) > -1 ? i[t](e) : i.attr(t, e);
        })), r;
      }, X.Z = function (t, e) {
        return t = t || [], t.__proto__ = j.fn, t.selector = e || "", t;
      }, X.isZ = function (t) {
        return t instanceof X.Z;
      }, X.init = function (t, n) {
        var r;if (!t) return X.Z();if ("string" == typeof t) {
          if (t = t.trim(), "<" == t[0] && _.test(t)) r = X.fragment(t, RegExp.$1, n), t = null;else {
            if (n !== w) return j(n).find(t);r = X.qsa(A, t);
          }
        } else {
          if (e(t)) return j(A).ready(t);if (X.isZ(t)) return t;if (G(t)) r = a(t);else if (i(t)) r = [t], t = null;else if (_.test(t)) r = X.fragment(t.trim(), RegExp.$1, n), t = null;else {
            if (n !== w) return j(n).find(t);r = X.qsa(A, t);
          }
        }return X.Z(r, t);
      }, j = function j(t, e) {
        return X.init(t, e);
      }, j.extend = function (t) {
        var e,
            n = O.call(arguments, 1);return "boolean" == typeof t && (e = t, t = n.shift()), n.forEach(function (n) {
          d(t, n, e);
        }), t;
      }, X.qsa = function (t, e) {
        var n,
            i = "#" == e[0],
            o = !i && "." == e[0],
            s = i || o ? e.slice(1) : e,
            a = B.test(s);return r(t) && a && i ? (n = t.getElementById(s)) ? [n] : [] : 1 !== t.nodeType && 9 !== t.nodeType ? [] : O.call(a && !i ? o ? t.getElementsByClassName(s) : t.getElementsByTagName(e) : t.querySelectorAll(e));
      }, j.contains = A.documentElement.contains ? function (t, e) {
        return t !== e && t.contains(e);
      } : function (t, e) {
        for (; e && (e = e.parentNode);) {
          if (e === t) return !0;
        }return !1;
      }, j.type = t, j.isFunction = e, j.isWindow = n, j.isArray = G, j.isPlainObject = o, j.isEmptyObject = function (t) {
        var e;for (e in t) {
          return !1;
        }return !0;
      }, j.inArray = function (t, e, n) {
        return S.indexOf.call(e, t, n);
      }, j.camelCase = C, j.trim = function (t) {
        return null == t ? "" : String.prototype.trim.call(t);
      }, j.uuid = 0, j.support = {}, j.expr = {}, j.map = function (t, e) {
        var n,
            r,
            i,
            o = [];if (s(t)) for (r = 0; t.length > r; r++) {
          n = e(t[r], r), null != n && o.push(n);
        } else for (i in t) {
          n = e(t[i], i), null != n && o.push(n);
        }return u(o);
      }, j.each = function (t, e) {
        var n, r;if (s(t)) {
          for (n = 0; t.length > n; n++) {
            if (e.call(t[n], n, t[n]) === !1) return t;
          }
        } else for (r in t) {
          if (e.call(t[r], r, t[r]) === !1) return t;
        }return t;
      }, j.grep = function (t, e) {
        return P.call(t, e);
      }, window.JSON && (j.parseJSON = JSON.parse), j.each("Boolean Number String Function Array Date RegExp Object Error".split(" "), function (t, e) {
        U["[object " + e + "]"] = e.toLowerCase();
      }), j.fn = { forEach: S.forEach, reduce: S.reduce, push: S.push, sort: S.sort, indexOf: S.indexOf, concat: S.concat, map: function map(t) {
          return j(j.map(this, function (e, n) {
            return t.call(e, n, e);
          }));
        }, slice: function slice() {
          return j(O.apply(this, arguments));
        }, ready: function ready(t) {
          return V.test(A.readyState) && A.body ? t(j) : A.addEventListener("DOMContentLoaded", function () {
            t(j);
          }, !1), this;
        }, get: function get(t) {
          return t === w ? O.call(this) : this[t >= 0 ? t : t + this.length];
        }, toArray: function toArray() {
          return this.get();
        }, size: function size() {
          return this.length;
        }, remove: function remove() {
          return this.each(function () {
            null != this.parentNode && this.parentNode.removeChild(this);
          });
        }, each: function each(t) {
          return S.every.call(this, function (e, n) {
            return t.call(e, n, e) !== !1;
          }), this;
        }, filter: function filter(t) {
          return e(t) ? this.not(this.not(t)) : j(P.call(this, function (e) {
            return X.matches(e, t);
          }));
        }, add: function add(t, e) {
          return j(T(this.concat(j(t, e))));
        }, is: function is(t) {
          return this.length > 0 && X.matches(this[0], t);
        }, not: function not(t) {
          var n = [];if (e(t) && t.call !== w) this.each(function (e) {
            t.call(this, e) || n.push(this);
          });else {
            var r = "string" == typeof t ? this.filter(t) : s(t) && e(t.item) ? O.call(t) : j(t);this.forEach(function (t) {
              0 > r.indexOf(t) && n.push(t);
            });
          }return j(n);
        }, has: function has(t) {
          return this.filter(function () {
            return i(t) ? j.contains(this, t) : j(this).find(t).size();
          });
        }, eq: function eq(t) {
          return -1 === t ? this.slice(t) : this.slice(t, +t + 1);
        }, first: function first() {
          var t = this[0];return t && !i(t) ? t : j(t);
        }, last: function last() {
          var t = this[this.length - 1];return t && !i(t) ? t : j(t);
        }, find: function find(t) {
          var e,
              n = this;return e = t ? "object" == (typeof t === "undefined" ? "undefined" : _typeof(t)) ? j(t).filter(function () {
            var t = this;return S.some.call(n, function (e) {
              return j.contains(e, t);
            });
          }) : 1 == this.length ? j(X.qsa(this[0], t)) : this.map(function () {
            return X.qsa(this, t);
          }) : [];
        }, closest: function closest(t, e) {
          var n = this[0],
              i = !1;for ("object" == (typeof t === "undefined" ? "undefined" : _typeof(t)) && (i = j(t)); n && !(i ? i.indexOf(n) >= 0 : X.matches(n, t));) {
            n = n !== e && !r(n) && n.parentNode;
          }return j(n);
        }, parents: function parents(t) {
          for (var e = [], n = this; n.length > 0;) {
            n = j.map(n, function (t) {
              return (t = t.parentNode) && !r(t) && 0 > e.indexOf(t) ? (e.push(t), t) : w;
            });
          }return m(e, t);
        }, parent: function parent(t) {
          return m(T(this.pluck("parentNode")), t);
        }, children: function children(t) {
          return m(this.map(function () {
            return p(this);
          }), t);
        }, contents: function contents() {
          return this.map(function () {
            return O.call(this.childNodes);
          });
        }, siblings: function siblings(t) {
          return m(this.map(function (t, e) {
            return P.call(p(e.parentNode), function (t) {
              return t !== e;
            });
          }), t);
        }, empty: function empty() {
          return this.each(function () {
            this.innerHTML = "";
          });
        }, pluck: function pluck(t) {
          return j.map(this, function (e) {
            return e[t];
          });
        }, show: function show() {
          return this.each(function () {
            "none" == this.style.display && (this.style.display = ""), "none" == getComputedStyle(this, "").getPropertyValue("display") && (this.style.display = h(this.nodeName));
          });
        }, replaceWith: function replaceWith(t) {
          return this.before(t).remove();
        }, wrap: function wrap(t) {
          var n = e(t);if (this[0] && !n) var r = j(t).get(0),
              i = r.parentNode || this.length > 1;return this.each(function (e) {
            j(this).wrapAll(n ? t.call(this, e) : i ? r.cloneNode(!0) : r);
          });
        }, wrapAll: function wrapAll(t) {
          if (this[0]) {
            j(this[0]).before(t = j(t));for (var e; (e = t.children()).length;) {
              t = e.first();
            }j(t).append(this);
          }return this;
        }, wrapInner: function wrapInner(t) {
          var n = e(t);return this.each(function (e) {
            var r = j(this),
                i = r.contents(),
                o = n ? t.call(this, e) : t;i.length ? i.wrapAll(o) : r.append(o);
          });
        }, unwrap: function unwrap() {
          return this.parent().each(function () {
            j(this).replaceWith(j(this).children());
          }), this;
        }, clone: function clone() {
          return this.map(function () {
            return this.cloneNode(!0);
          });
        }, hide: function hide() {
          return this.css("display", "none");
        }, toggle: function toggle(t) {
          return this.each(function () {
            var e = j(this);(t === w ? "none" == e.css("display") : t) ? e.show() : e.hide();
          });
        }, prev: function prev(t) {
          return j(this.pluck("previousElementSibling")).filter(t || "*");
        }, next: function next(t) {
          return j(this.pluck("nextElementSibling")).filter(t || "*");
        }, html: function html(t) {
          return 0 in arguments ? this.each(function (e) {
            var n = this.innerHTML;j(this).empty().append(v(this, t, e, n));
          }) : 0 in this ? this[0].innerHTML : null;
        }, text: function text(t) {
          return 0 in arguments ? this.each(function (e) {
            var n = v(this, t, e, this.textContent);this.textContent = null == n ? "" : "" + n;
          }) : 0 in this ? this[0].textContent : null;
        }, attr: function attr(t, e) {
          var n;return "string" != typeof t || 1 in arguments ? this.each(function (n) {
            if (1 === this.nodeType) if (i(t)) for (E in t) {
              g(this, E, t[E]);
            } else g(this, t, v(this, e, n, this.getAttribute(t)));
          }) : this.length && 1 === this[0].nodeType ? !(n = this[0].getAttribute(t)) && t in this[0] ? this[0][t] : n : w;
        }, removeAttr: function removeAttr(t) {
          return this.each(function () {
            1 === this.nodeType && g(this, t);
          });
        }, prop: function prop(t, e) {
          return t = Y[t] || t, 1 in arguments ? this.each(function (n) {
            this[t] = v(this, e, n, this[t]);
          }) : this[0] && this[0][t];
        }, data: function data(t, e) {
          var n = "data-" + t.replace(q, "-$1").toLowerCase(),
              r = 1 in arguments ? this.attr(n, e) : this.attr(n);return null !== r ? x(r) : w;
        }, val: function val(t) {
          return 0 in arguments ? this.each(function (e) {
            this.value = v(this, t, e, this.value);
          }) : this[0] && (this[0].multiple ? j(this[0]).find("option").filter(function () {
            return this.selected;
          }).pluck("value") : this[0].value);
        }, offset: function offset(t) {
          if (t) return this.each(function (e) {
            var n = j(this),
                r = v(this, t, e, n.offset()),
                i = n.offsetParent().offset(),
                o = { top: r.top - i.top, left: r.left - i.left };"static" == n.css("position") && (o.position = "relative"), n.css(o);
          });if (!this.length) return null;var e = this[0].getBoundingClientRect();return { left: e.left + window.pageXOffset, top: e.top + window.pageYOffset, width: Math.round(e.width), height: Math.round(e.height) };
        }, css: function css(e, n) {
          if (2 > arguments.length) {
            var r = this[0],
                i = getComputedStyle(r, "");if (!r) return;if ("string" == typeof e) return r.style[C(e)] || i.getPropertyValue(e);if (G(e)) {
              var o = {};return j.each(e, function (t, e) {
                o[e] = r.style[C(e)] || i.getPropertyValue(e);
              }), o;
            }
          }var s = "";if ("string" == t(e)) n || 0 === n ? s = c(e) + ":" + f(e, n) : this.each(function () {
            this.style.removeProperty(c(e));
          });else for (E in e) {
            e[E] || 0 === e[E] ? s += c(E) + ":" + f(E, e[E]) + ";" : this.each(function () {
              this.style.removeProperty(c(E));
            });
          }return this.each(function () {
            this.style.cssText += ";" + s;
          });
        }, index: function index(t) {
          return t ? this.indexOf(j(t)[0]) : this.parent().children().indexOf(this[0]);
        }, hasClass: function hasClass(t) {
          return t ? S.some.call(this, function (t) {
            return this.test(y(t));
          }, l(t)) : !1;
        }, addClass: function addClass(t) {
          return t ? this.each(function (e) {
            if ("className" in this) {
              N = [];var n = y(this),
                  r = v(this, t, e, n);r.split(/\s+/g).forEach(function (t) {
                j(this).hasClass(t) || N.push(t);
              }, this), N.length && y(this, n + (n ? " " : "") + N.join(" "));
            }
          }) : this;
        }, removeClass: function removeClass(t) {
          return this.each(function (e) {
            if ("className" in this) {
              if (t === w) return y(this, "");N = y(this), v(this, t, e, N).split(/\s+/g).forEach(function (t) {
                N = N.replace(l(t), " ");
              }), y(this, N.trim());
            }
          });
        }, toggleClass: function toggleClass(t, e) {
          return t ? this.each(function (n) {
            var r = j(this),
                i = v(this, t, n, y(this));i.split(/\s+/g).forEach(function (t) {
              (e === w ? !r.hasClass(t) : e) ? r.addClass(t) : r.removeClass(t);
            });
          }) : this;
        }, scrollTop: function scrollTop(t) {
          if (this.length) {
            var e = "scrollTop" in this[0];return t === w ? e ? this[0].scrollTop : this[0].pageYOffset : this.each(e ? function () {
              this.scrollTop = t;
            } : function () {
              this.scrollTo(this.scrollX, t);
            });
          }
        }, scrollLeft: function scrollLeft(t) {
          if (this.length) {
            var e = "scrollLeft" in this[0];return t === w ? e ? this[0].scrollLeft : this[0].pageXOffset : this.each(e ? function () {
              this.scrollLeft = t;
            } : function () {
              this.scrollTo(t, this.scrollY);
            });
          }
        }, position: function position() {
          if (this.length) {
            var t = this[0],
                e = this.offsetParent(),
                n = this.offset(),
                r = k.test(e[0].nodeName) ? { top: 0, left: 0 } : e.offset();return n.top -= parseFloat(j(t).css("margin-top")) || 0, n.left -= parseFloat(j(t).css("margin-left")) || 0, r.top += parseFloat(j(e[0]).css("border-top-width")) || 0, r.left += parseFloat(j(e[0]).css("border-left-width")) || 0, { top: n.top - r.top, left: n.left - r.left };
          }
        }, offsetParent: function offsetParent() {
          return this.map(function () {
            for (var t = this.offsetParent || A.body; t && !k.test(t.nodeName) && "static" == j(t).css("position");) {
              t = t.offsetParent;
            }return t;
          });
        } }, j.fn.detach = j.fn.remove, ["width", "height"].forEach(function (t) {
        var e = t.replace(/./, function (t) {
          return t[0].toUpperCase();
        });j.fn[t] = function (i) {
          var o,
              s = this[0];return i === w ? n(s) ? s["inner" + e] : r(s) ? s.documentElement["scroll" + e] : (o = this.offset()) && o[t] : this.each(function (e) {
            s = j(this), s.css(t, v(this, i, e, s[t]()));
          });
        };
      }), z.forEach(function (e, n) {
        var r = n % 2;j.fn[e] = function () {
          var e,
              i,
              o = j.map(arguments, function (n) {
            return e = t(n), "object" == e || "array" == e || null == n ? n : X.fragment(n);
          }),
              s = this.length > 1;return 1 > o.length ? this : this.each(function (t, e) {
            i = r ? e : e.parentNode, e = 0 == n ? e.nextSibling : 1 == n ? e.firstChild : 2 == n ? e : null;var a = j.contains(A.documentElement, i);o.forEach(function (t) {
              if (s) t = t.cloneNode(!0);else if (!i) return j(t).remove();i.insertBefore(t, e), a && b(t, function (t) {
                null == t.nodeName || "SCRIPT" !== t.nodeName.toUpperCase() || t.type && "text/javascript" !== t.type || t.src || window.eval.call(window, t.innerHTML);
              });
            });
          });
        }, j.fn[r ? e + "To" : "insert" + (n ? "Before" : "After")] = function (t) {
          return j(t)[e](this), this;
        };
      }), X.Z.prototype = j.fn, X.uniq = T, X.deserializeValue = x, j.zepto = X, j;
    }();window.Zepto = Zepto, void 0 === window.$ && (window.$ = Zepto), function (t) {
      function e(e, n, r) {
        var i = t.Event(n);return t(e).trigger(i, r), !i.isDefaultPrevented();
      }function n(t, n, r, i) {
        return t.global ? e(n || y, r, i) : void 0;
      }function r(e) {
        e.global && 0 === t.active++ && n(e, null, "ajaxStart");
      }function i(e) {
        e.global && ! --t.active && n(e, null, "ajaxStop");
      }function o(t, e) {
        var r = e.context;return e.beforeSend.call(r, t, e) === !1 || n(e, r, "ajaxBeforeSend", [t, e]) === !1 ? !1 : (n(e, r, "ajaxSend", [t, e]), void 0);
      }function s(t, e, r, i) {
        var o = r.context,
            s = "success";r.success.call(o, t, s, e), i && i.resolveWith(o, [t, s, e]), n(r, o, "ajaxSuccess", [e, r, t]), u(s, e, r);
      }function a(t, e, r, i, o) {
        var s = i.context;i.error.call(s, r, e, t), o && o.rejectWith(s, [r, e, t]), n(i, s, "ajaxError", [r, i, t || e]), u(e, r, i);
      }function u(t, e, r) {
        var o = r.context;r.complete.call(o, e, t), n(r, o, "ajaxComplete", [e, r]), i(r);
      }function c() {}function l(t) {
        return t && (t = t.split(";", 2)[0]), t && (t == j ? "html" : t == E ? "json" : b.test(t) ? "script" : w.test(t) && "xml") || "text";
      }function f(t, e) {
        return "" == e ? t : (t + "&" + e).replace(/[&?]{1,2}/, "?");
      }function h(e) {
        e.processData && e.data && "string" != t.type(e.data) && (e.data = t.param(e.data, e.traditional)), !e.data || e.type && "GET" != e.type.toUpperCase() || (e.url = f(e.url, e.data), e.data = void 0);
      }function p(e, n, r, i) {
        return t.isFunction(n) && (i = r, r = n, n = void 0), t.isFunction(r) || (i = r, r = void 0), { url: e, data: n, success: r, dataType: i };
      }function d(e, n, r, i) {
        var o,
            s = t.isArray(n),
            a = t.isPlainObject(n);t.each(n, function (n, u) {
          o = t.type(u), i && (n = r ? i : i + "[" + (a || "object" == o || "array" == o ? n : "") + "]"), !i && s ? e.add(u.name, u.value) : "array" == o || !r && "object" == o ? d(e, u, r, n) : e.add(n, u);
        });
      }var m,
          v,
          g = 0,
          y = window.document,
          x = /<script\b[^<]*(?:(?!<\/script>)<[^<]*)*<\/script>/gi,
          b = /^(?:text|application)\/javascript/i,
          w = /^(?:text|application)\/xml/i,
          E = "application/json",
          j = "text/html",
          N = /^\s*$/;t.active = 0, t.ajaxJSONP = function (e, n) {
        if (!("type" in e)) return t.ajax(e);var r,
            i,
            u = e.jsonpCallback,
            c = (t.isFunction(u) ? u() : u) || "jsonp" + ++g,
            l = y.createElement("script"),
            f = window[c],
            h = function h(e) {
          t(l).triggerHandler("error", e || "abort");
        },
            p = { abort: h };return n && n.promise(p), t(l).on("load error", function (o, u) {
          clearTimeout(i), t(l).off().remove(), "error" != o.type && r ? s(r[0], p, e, n) : a(null, u || "error", p, e, n), window[c] = f, r && t.isFunction(f) && f(r[0]), f = r = void 0;
        }), o(p, e) === !1 ? (h("abort"), p) : (window[c] = function () {
          r = arguments;
        }, l.src = e.url.replace(/\?(.+)=\?/, "?$1=" + c), y.head.appendChild(l), e.timeout > 0 && (i = setTimeout(function () {
          h("timeout");
        }, e.timeout)), p);
      }, t.ajaxSettings = { type: "GET", beforeSend: c, success: c, error: c, complete: c, context: null, global: !0, xhr: function xhr() {
          return new window.XMLHttpRequest();
        }, accepts: { script: "text/javascript, application/javascript, application/x-javascript", json: E, xml: "application/xml, text/xml", html: j, text: "text/plain" }, crossDomain: !1, timeout: 0, processData: !0, cache: !0 }, t.ajax = function (e) {
        var n = t.extend({}, e || {}),
            i = t.Deferred && t.Deferred();for (m in t.ajaxSettings) {
          void 0 === n[m] && (n[m] = t.ajaxSettings[m]);
        }r(n), n.crossDomain || (n.crossDomain = /^([\w-]+:)?\/\/([^\/]+)/.test(n.url) && RegExp.$2 != window.location.host), n.url || (n.url = "" + window.location), h(n);var u = n.dataType,
            p = /\?.+=\?/.test(n.url);if (p && (u = "jsonp"), n.cache !== !1 && (e && e.cache === !0 || "script" != u && "jsonp" != u) || (n.url = f(n.url, "_=" + Date.now())), "jsonp" == u) return p || (n.url = f(n.url, n.jsonp ? n.jsonp + "=?" : n.jsonp === !1 ? "" : "callback=?")), t.ajaxJSONP(n, i);var d,
            g = n.accepts[u],
            y = {},
            x = function x(t, e) {
          y[t.toLowerCase()] = [t, e];
        },
            b = /^([\w-]+:)\/\//.test(n.url) ? RegExp.$1 : window.location.protocol,
            w = n.xhr(),
            E = w.setRequestHeader;if (i && i.promise(w), n.crossDomain || x("X-Requested-With", "XMLHttpRequest"), x("Accept", g || "*/*"), (g = n.mimeType || g) && (g.indexOf(",") > -1 && (g = g.split(",", 2)[0]), w.overrideMimeType && w.overrideMimeType(g)), (n.contentType || n.contentType !== !1 && n.data && "GET" != n.type.toUpperCase()) && x("Content-Type", n.contentType || "application/x-www-form-urlencoded"), n.headers) for (v in n.headers) {
          x(v, n.headers[v]);
        }if (w.setRequestHeader = x, w.onreadystatechange = function () {
          if (4 == w.readyState) {
            w.onreadystatechange = c, clearTimeout(d);var e,
                r = !1;if (w.status >= 200 && 300 > w.status || 304 == w.status || 0 == w.status && "file:" == b) {
              u = u || l(n.mimeType || w.getResponseHeader("content-type")), e = w.responseText;try {
                "script" == u ? (1, eval)(e) : "xml" == u ? e = w.responseXML : "json" == u && (e = N.test(e) ? null : t.parseJSON(e));
              } catch (o) {
                r = o;
              }r ? a(r, "parsererror", w, n, i) : s(e, w, n, i);
            } else a(w.statusText || null, w.status ? "error" : "abort", w, n, i);
          }
        }, o(w, n) === !1) return w.abort(), a(null, "abort", w, n, i), w;var j = "async" in n ? n.async : !0;w.open(n.type, n.url, j, n.username, n.password);if (n.xhrFields) for (v in n.xhrFields) {
          w[v] = n.xhrFields[v];
        }for (v in y) {
          E.apply(w, y[v]);
        }return n.timeout > 0 && (d = setTimeout(function () {
          w.onreadystatechange = c, w.abort(), a(null, "timeout", w, n, i);
        }, n.timeout)), w.send(n.data ? n.data : null), w;
      }, t.get = function () {
        return t.ajax(p.apply(null, arguments));
      }, t.post = function () {
        var e = p.apply(null, arguments);return e.type = "POST", t.ajax(e);
      }, t.getJSON = function () {
        var e = p.apply(null, arguments);return e.dataType = "json", t.ajax(e);
      }, t.fn.load = function (e, n, r) {
        if (!this.length) return this;var i,
            o = this,
            s = e.split(/\s/),
            a = p(e, n, r),
            u = a.success;return s.length > 1 && (a.url = s[0], i = s[1]), a.success = function (e) {
          o.html(i ? t("<div>").html(e.replace(x, "")).find(i) : e), u && u.apply(o, arguments);
        }, t.ajax(a), this;
      };var C = encodeURIComponent;t.param = function (t, e) {
        var n = [];return n.add = function (t, e) {
          this.push(C(t) + "=" + C(e));
        }, d(n, t, e), n.join("&").replace(/%20/g, "+");
      };
    }(Zepto), function (t) {
      function e(t) {
        return t._zid || (t._zid = h++);
      }function n(t, n, o, s) {
        if (n = r(n), n.ns) var a = i(n.ns);return (v[e(t)] || []).filter(function (t) {
          return !(!t || n.e && t.e != n.e || n.ns && !a.test(t.ns) || o && e(t.fn) !== e(o) || s && t.sel != s);
        });
      }function r(t) {
        var e = ("" + t).split(".");return { e: e[0], ns: e.slice(1).sort().join(" ") };
      }function i(t) {
        return RegExp("(?:^| )" + t.replace(" ", " .* ?") + "(?: |$)");
      }function o(t, e) {
        return t.del && !y && t.e in x || !!e;
      }function s(t) {
        return b[t] || y && x[t] || t;
      }function a(n, i, a, u, l, h, p) {
        var d = e(n),
            m = v[d] || (v[d] = []);i.split(/\s/).forEach(function (e) {
          if ("ready" == e) return t(document).ready(a);var i = r(e);i.fn = a, i.sel = l, i.e in b && (a = function a(e) {
            var n = e.relatedTarget;return !n || n !== this && !t.contains(this, n) ? i.fn.apply(this, arguments) : f;
          }), i.del = h;var d = h || a;i.proxy = function (t) {
            if (t = c(t), !t.isImmediatePropagationStopped()) {
              t.data = u;var e = d.apply(n, t._args == f ? [t] : [t].concat(t._args));return e === !1 && (t.preventDefault(), t.stopPropagation()), e;
            }
          }, i.i = m.length, m.push(i), "addEventListener" in n && n.addEventListener(s(i.e), i.proxy, o(i, p));
        });
      }function u(t, r, i, a, u) {
        var c = e(t);(r || "").split(/\s/).forEach(function (e) {
          n(t, e, i, a).forEach(function (e) {
            delete v[c][e.i], "removeEventListener" in t && t.removeEventListener(s(e.e), e.proxy, o(e, u));
          });
        });
      }function c(e, n) {
        return (n || !e.isDefaultPrevented) && (n || (n = e), t.each(N, function (t, r) {
          var i = n[t];e[t] = function () {
            return this[r] = w, i && i.apply(n, arguments);
          }, e[r] = E;
        }), (n.defaultPrevented !== f ? n.defaultPrevented : "returnValue" in n ? n.returnValue === !1 : n.getPreventDefault && n.getPreventDefault()) && (e.isDefaultPrevented = w)), e;
      }function l(t) {
        var e,
            n = { originalEvent: t };for (e in t) {
          j.test(e) || t[e] === f || (n[e] = t[e]);
        }return c(n, t);
      }var f,
          h = 1,
          p = Array.prototype.slice,
          d = t.isFunction,
          m = function m(t) {
        return "string" == typeof t;
      },
          v = {},
          g = {},
          y = "onfocusin" in window,
          x = { focus: "focusin", blur: "focusout" },
          b = { mouseenter: "mouseover", mouseleave: "mouseout" };g.click = g.mousedown = g.mouseup = g.mousemove = "MouseEvents", t.event = { add: a, remove: u }, t.proxy = function (n, r) {
        var i = 2 in arguments && p.call(arguments, 2);if (d(n)) {
          var o = function o() {
            return n.apply(r, i ? i.concat(p.call(arguments)) : arguments);
          };return o._zid = e(n), o;
        }if (m(r)) return i ? (i.unshift(n[r], n), t.proxy.apply(null, i)) : t.proxy(n[r], n);throw new TypeError("expected function");
      }, t.fn.bind = function (t, e, n) {
        return this.on(t, e, n);
      }, t.fn.unbind = function (t, e) {
        return this.off(t, e);
      }, t.fn.one = function (t, e, n, r) {
        return this.on(t, e, n, r, 1);
      };var w = function w() {
        return !0;
      },
          E = function E() {
        return !1;
      },
          j = /^([A-Z]|returnValue$|layer[XY]$)/,
          N = { preventDefault: "isDefaultPrevented", stopImmediatePropagation: "isImmediatePropagationStopped", stopPropagation: "isPropagationStopped" };t.fn.delegate = function (t, e, n) {
        return this.on(e, t, n);
      }, t.fn.undelegate = function (t, e, n) {
        return this.off(e, t, n);
      }, t.fn.live = function (e, n) {
        return t(document.body).delegate(this.selector, e, n), this;
      }, t.fn.die = function (e, n) {
        return t(document.body).undelegate(this.selector, e, n), this;
      }, t.fn.on = function (e, n, r, i, o) {
        var s,
            c,
            h = this;return e && !m(e) ? (t.each(e, function (t, e) {
          h.on(t, n, r, e, o);
        }), h) : (m(n) || d(i) || i === !1 || (i = r, r = n, n = f), (d(r) || r === !1) && (i = r, r = f), i === !1 && (i = E), h.each(function (h, d) {
          o && (s = function s(t) {
            return u(d, t.type, i), i.apply(this, arguments);
          }), n && (c = function c(e) {
            var r,
                o = t(e.target).closest(n, d).get(0);return o && o !== d ? (r = t.extend(l(e), { currentTarget: o, liveFired: d }), (s || i).apply(o, [r].concat(p.call(arguments, 1)))) : f;
          }), a(d, e, i, r, n, c || s);
        }));
      }, t.fn.off = function (e, n, r) {
        var i = this;return e && !m(e) ? (t.each(e, function (t, e) {
          i.off(t, n, e);
        }), i) : (m(n) || d(r) || r === !1 || (r = n, n = f), r === !1 && (r = E), i.each(function () {
          u(this, e, r, n);
        }));
      }, t.fn.trigger = function (e, n) {
        return e = m(e) || t.isPlainObject(e) ? t.Event(e) : c(e), e._args = n, this.each(function () {
          "dispatchEvent" in this ? this.dispatchEvent(e) : t(this).triggerHandler(e, n);
        });
      }, t.fn.triggerHandler = function (e, r) {
        var i, o;return this.each(function (s, a) {
          i = l(m(e) ? t.Event(e) : e), i._args = r, i.target = a, t.each(n(a, e.type || e), function (t, e) {
            return o = e.proxy(i), i.isImmediatePropagationStopped() ? !1 : f;
          });
        }), o;
      }, "focusin focusout load resize scroll unload click dblclick mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave change select keydown keypress keyup error".split(" ").forEach(function (e) {
        t.fn[e] = function (t) {
          return t ? this.bind(e, t) : this.trigger(e);
        };
      }), ["focus", "blur"].forEach(function (e) {
        t.fn[e] = function (t) {
          return t ? this.bind(e, t) : this.each(function () {
            try {
              this[e]();
            } catch (t) {}
          }), this;
        };
      }), t.Event = function (t, e) {
        m(t) || (e = t, t = e.type);var n = document.createEvent(g[t] || "Events"),
            r = !0;if (e) for (var i in e) {
          "bubbles" == i ? r = !!e[i] : n[i] = e[i];
        }return n.initEvent(t, r, !0), c(n);
      };
    }(Zepto), function (t) {
      t.fn.serializeArray = function () {
        var e,
            n,
            r = [];return t([].slice.call(this.get(0).elements)).each(function () {
          e = t(this), n = e.attr("type"), "fieldset" != this.nodeName.toLowerCase() && !this.disabled && "submit" != n && "reset" != n && "button" != n && ("radio" != n && "checkbox" != n || this.checked) && r.push({ name: e.attr("name"), value: e.val() });
        }), r;
      }, t.fn.serialize = function () {
        var t = [];return this.serializeArray().forEach(function (e) {
          t.push(encodeURIComponent(e.name) + "=" + encodeURIComponent(e.value));
        }), t.join("&");
      }, t.fn.submit = function (e) {
        if (e) this.bind("submit", e);else if (this.length) {
          var n = t.Event("submit");this.eq(0).trigger(n), n.isDefaultPrevented() || this.get(0).submit();
        }return this;
      };
    }(Zepto), function (t) {
      "__proto__" in {} || t.extend(t.zepto, { Z: function Z(e, n) {
          return e = e || [], t.extend(e, t.fn), e.selector = n || "", e.__Z = !0, e;
        }, isZ: function isZ(e) {
          return "array" === t.type(e) && "__Z" in e;
        } });try {
        getComputedStyle(void 0);
      } catch (e) {
        var n = getComputedStyle;window.getComputedStyle = function (t) {
          try {
            return n(t);
          } catch (e) {
            return null;
          }
        };
      }
    }(Zepto), function (t) {
      function e(e) {
        return e = t(e), !(!e.width() && !e.height()) && "none" !== e.css("display");
      }function n(t, e) {
        t = t.replace(/=#\]/g, '="#"]');var n,
            r,
            i = a.exec(t);if (i && i[2] in s && (n = s[i[2]], r = i[3], t = i[1], r)) {
          var o = Number(r);r = isNaN(o) ? r.replace(/^["']|["']$/g, "") : o;
        }return e(t, n, r);
      }var r = t.zepto,
          i = r.qsa,
          o = r.matches,
          s = t.expr[":"] = { visible: function visible() {
          return e(this) ? this : void 0;
        }, hidden: function hidden() {
          return e(this) ? void 0 : this;
        }, selected: function selected() {
          return this.selected ? this : void 0;
        }, checked: function checked() {
          return this.checked ? this : void 0;
        }, parent: function parent() {
          return this.parentNode;
        }, first: function first(t) {
          return 0 === t ? this : void 0;
        }, last: function last(t, e) {
          return t === e.length - 1 ? this : void 0;
        }, eq: function eq(t, e, n) {
          return t === n ? this : void 0;
        }, contains: function contains(e, n, r) {
          return t(this).text().indexOf(r) > -1 ? this : void 0;
        }, has: function has(t, e, n) {
          return r.qsa(this, n).length ? this : void 0;
        } },
          a = RegExp("(.*):(\\w+)(?:\\(([^)]+)\\))?$\\s*"),
          u = /^\s*>/,
          c = "Zepto" + +new Date();r.qsa = function (e, o) {
        return n(o, function (n, s, a) {
          try {
            var l;!n && s ? n = "*" : u.test(n) && (l = t(e).addClass(c), n = "." + c + " " + n);var f = i(e, n);
          } catch (h) {
            throw console.error("error performing selector: %o", o), h;
          } finally {
            l && l.removeClass(c);
          }return s ? r.uniq(t.map(f, function (t, e) {
            return s.call(t, e, f, a);
          })) : f;
        });
      }, r.matches = function (t, e) {
        return n(e, function (e, n, r) {
          return !(e && !o(t, e) || n && n.call(t, null, r) !== t);
        });
      };
    }(Zepto);
  }, {}] }, {}, [4]);